import { useState, useEffect, useCallback } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink, useNavigate, useParams, useLocation, NavLink } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { Formik, Form, Field } from 'formik';
import { toast } from "react-toastify";
import $ from 'jquery';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box, Modal } from '@mui/material';
import { format } from 'date-fns';
import * as userActions from "../../actions/userActions";
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import '../common.scss';
import * as leadActions from "../../actions/leadActions";
import * as masterAction from "../../actions/masterAction";
import AccessDenied from '../common/AccessDenied';
import * as incidentReporteActions from "../../actions/incidentReporteActions";
import CoApplicant from './CoApplicant';
import Guarantor from './Guarantor';
import * as groupsUsersActions from "../../actions/groupsUsersActions";


// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
    maxWidth: 480,
    margin: 'auto',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------
const SendToAllcloudPage = (props) => {
    const { id, actionName } = useParams();
    const { urlLoanApplicationID, enachid } = useParams();
    
    const location = useLocation();
    const { actions, leadsData, leadInfo, usersData, basicLeadInfo, masterProfileData, leadChecklistData, interactionTypeData, getUserModuleData, incidentReporteData, leadGstByLeadData, leadItrByLeadData, leadBankStatementByLeadData } = props;
     const [open, setOpen] = useState(false);
     
    const [showLeadDetails, setShowLeadDetails] = useState(false);
    const [leadData, setLeadData] = useState([]);
    const [leadId, setLeadId] = useState('');
    const [loanApplicationID, setLoanApplicationID] = useState('');
    const [enachId, setEnachId] = useState('');
    const [isFleetCase, setIsFleetCase] = useState(false);
     const [allUsers, setAllUsers] = useState([]);
    const { register, handleSubmit, formState: { errors }, setValue } = useForm();
    const navigate = useNavigate();
    const [customerCreatedStatus, setCustomerCreatedStatus] = useState(false);
    const [customerID, setCustomerID] = useState('');

    const [allCloudCustomerCreatedStatus, setAllCloudCustomerCreatedStatus] = useState(false);
    const [allCloudCustomerID, setAllCloudCustomerID] = useState('');
    const [allCloudLeadID, setAllCloudLeadID] = useState('');
    const [allCloudLocalLeadID, setAllCloudLocalLeadID] = useState('');
    const [allCloudLoanLeadID, setAllCloudLoanLeadID] = useState('');
    const [loanEnachId, setLoanEnachId] = useState('');
 
    const [allMasterProfiles, setAllMasterProfiles] = useState([]);
    const [pageHeading, setPageHeading] = useState('');

    const [addModulePermissionStatus, setAddModulePermissionStatus] = useState(false);
    const [editModulePermissionStatus, setEditModulePermissionStatus] = useState(false);
    const [userHasPermission, setUserHasPermission] = useState(true);
    const [permissions, setPermissions] = useState([]);

    const [panDetailsInfoGender, setPanDetailsInfoGender] = useState('');
    const [panDetailsInfoAddress, setPanDetailsInfoAddress] = useState('');
    const [leadPanDetails, setLeadPanDetails] = useState('');

    const [allGroupData, setAllGroupData] = useState([]);
    const [allCloudLoanSegments, setAllCloudLoanSegments] = useState([]);

    const [userRoleType, setUserRoleType] = useState('User');
    const [loggeInUserID, setLoggeInUserID] = useState('');
    const [isCrifUser, setIsCrifUser] = useState(true);

    const [allStates, setAllStates] = useState([]);
    const [allAddressTypes, setAllAddressTypes] = useState([]);
    const [showNote, setShowNote] = useState('');
    const [showNoteNoteByCredit, setShowNoteNoteByCredit] = useState('');

    const [selectedAssignedGroup, setSelectedAssignedGroup] = useState('');
    const [assignedUser, setAssignedUser] = useState("");

    const [isSentToCredit, setIsSentToCredit] = useState(true);

    const [allLeadActivity, setAllLeadActivity] = useState([]);


    const [scoreCard, setScoreCard] = useState("");
    const [allCloudCustomerInfo, setAllCloudCustomerInfo] = useState([]);
    const [selectedSchemes, setSelectedSchemes] = useState("");
    const [allCloudSchemes, setAllCloudSchemes] = useState([]);
    const [allCloudLoanCategories, setAllCloudLoanCategories] = useState([]);
    const [allCloudLeadSources, setAllCloudLeadSources] = useState([]);
    const [allCloudCustomerLeadInfo, setAllCloudCustomerLeadInfo] = useState([]);
    const [customerLeadCreatedStatus, setCustomerLeadCreatedStatus] = useState(false);

    const [allCloudCustomerLoanInfo, setAllCloudCustomerLoanInfo] = useState([]);
    const [customerLoanCreatedStatus, setCustomerLoanCreatedStatus] = useState(false);

    const [allCloudOrganizationTypes, setAllCloudOrganizationTypes] = useState([]);
    const [allCloudProductTypes, setAllCloudProductTypes] = useState([]);
    const [allCloudLpcTypes, setAllCloudLpcTypes] = useState([]);
    const [allCloudEmploymentTypes, setAllCloudEmploymentTypes] = useState([]);
    const [companyDetailsStatus, setCompanyDetailsStatus] = useState(false);

    const [loanTypeIdArr, setLoanTypeIdArr] = useState([]);

    const [allDealerArr, setAllDealerArr] = useState([]);
    const [allSourcesNameArr, setAllSourcesNameArr] = useState([]);

    const [dealerArr, setDealerArr] = useState([]);
    const [sourcesNameArr, setSourcesNameArr] = useState([]);
    const [companyRoleArr, setCompanyRoleArr] = useState([]);
    const [purposeOfLoanArr, setPurposeOfLoanArr] = useState([]);
    const [vehiclesTypeArr, setVehiclesTypeArr] = useState([]);

    const [allVehicleMakeArr, setAllVehicleMakeArr] = useState([]);
    const [vehicleMakeArr, setVehicleMakeArr] = useState([]);
    const [centresArr, setCentresArr] = useState([]);
    const [centresFilteredArr, setCentresFilteredArr] = useState([]);

    const [allVehicleClassArr, setAllVehicleClassArr] = useState([]);
    const [vehicleClassArr, setVehicleClassArr] = useState([]);

    const [allVehicleClassVariantArr, setAllVehicleClassVariantArr] = useState([]);
    const [vehicleClassVariantArr, setVehicleClassVariantArr] = useState([]);
    const [formCAMValues, setFormCAMValues] = useState({});
    const [isDropdownDisabled, setIsDropdownDisabled] = useState(false);
    const [isPurposeOfLoanDropdownDisabled, setIsPurposeOfLoanDropdownDisabled] = useState(false);
    const [isLoanTypeDropdownDisabled, setIsLoanTypeDropdownDisabled] = useState(false);

    const [isLoanSegmentDropdownDisabled, setIsLoanSegmentDropdownDisabled] = useState(false);

    const [currentDate, setCurrentDate] = useState(() => {
            const today = new Date();
            return today.toISOString().split('T')[0]; // "YYYY-MM-DD"
        });

    const [isLoanAmountDisabled, setIsLoanAmountDisabled] = useState(false); 
    const [isLoanTenureDisabled, setIsLoanTenureDisabled] = useState(false); 
    const [isLoanCategoryDisabled, setIsLoanCategoryDisabled] = useState(false);
    const [isProductTypeDisabled, setIsProductTypeDisabled] = useState(false);  
     const [isEmployerNameDisabled, setIsEmployerNameDisabled] = useState(false); 
     const [isAssetValueDisabled, setIsAssetValueDisabled] = useState(false);
     const [isSanctionAmountDisabled, setIsSanctionAmountDisabled] = useState(false); 
     const [camAutoApprovedStatus, setCamAutoApprovedStatus] = useState(false);   
     const [isSanctionRecordExistStatus, setSanctionRecordExistStatus] = useState(true);
     const [isDORecordExistStatus, setDORecordExistStatus] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [sendEmailBtnAction, setSendEmailBtnAction] = useState(0);
    const [approveBtnAction, setApproveBtnAction] = useState(0);

    const handleCloseModal = () => {     // Modal onclick closedFun
        setApproveBtnAction('');
        setOpenModal(false);
        setSendEmailBtnAction(0);
    }; 

    const btnOpenSendMail = (approveBtnAction,sendEmail='0') => {    // buttonFun 
        setApproveBtnAction(approveBtnAction);
        setOpenModal(true);
        setSendEmailBtnAction(sendEmail);
    };

    const handleCloseSendMail = () => {     // Modal onclick closedFun
         setApproveBtnAction(0);
         setOpenModal(false);
         setSendEmailBtnAction(0);
       };

     const [formValues, setFormValues] = useState({
        customerType: 'Individual',
        credit_score: '',
        remarks: '',
        caste: '',
        phone_number: '',
        contactreferencedto_name: '',
        contactreferencedto_contactnumber: '',
        contactreferencedto_town: '',
        contactreferencedto_address: '',
        contactreferencedto_area: '',
        contactreferencedto_postcode: '',
        company_name:'',
        customer_state:'',
        name_to_be_display:''
    });
 
    const [formLeadValues, setFormLeadValues] = useState({
        CompanyRoleId:'198',
        LoanSegmentId:'24',
        PurposeofLoan:'9',
        ProductTypeId:'VehicleLoan',
        loan_category:'General',
        lead_source: '',
        DealerId:'',
        lead_source_detail_id:'206',
        scheme_id:'20',
        mfgYear:'',
        vehicleTypeId:'20',
        vehicleClassId:'12',
        vehicleMakeId:'229',
        vehicleClassVariantId:'2',
        EmployerName:'',
        AnnualSalary:'100000',
        JoiningDate: currentDate,
        Designation:'NA',
        OrganizationType:'NA',
        Sector:'NA',
        AddressLine1:'NA',
        Area:'NA',
        Town:'NA',
        Postcode:'',
        OrganizationName:'NA',
        AnnualProfit:'100000',
        IncorporationDate:currentDate,
        IncorporationOrganizationType:'',
        AnnualIncome:'100000',
        IncorporationAddressLine1:'NA',
        IncorporationArea:'NA',
        IncorporationTown:'NA',
        IncorporationPostcode:'NA',
        IOTCompanyName:'NA',
        BatteryCompanyName:'NA',
        LoanAmount:'',
        LoanTenure:'',
        CentreName:'',
        DownPayment:'',
        LoanState:'0',
        LoanTypeId:'0',
        SubLoanTypeId:'0',
        ComfortableEMI:'1',
        AddressId:'0'
    });
   
    const [formLoanValues, setFormLoanValues] = useState({
        CompanyRoleId:'',
        LoanStateForPL: 'Unsecured',
        YearlyInterest: '',
        SanctionAmount: '',
        EMIStartDate: '',
        InstallmentTypeId: 'Monthly',
        ModeOfRePaymentId: 'eNACH',
        StartDate: '',
        LPC: '0',
        LPCType: '',
        EmploymentType: '',
        LoanAgreementNo: '',
        AssetValue: '0',
        UpFrontFee: '0', 
    });

    const [formPREEMIValues, setFormPREEMIValues] = useState({
        pre_emi_start_date:'',
        pre_emi_end_date:'',
        pre_emi_type:'', 
        pre_emi:'', 
        total_down_payment_by_customer:'',
        disbursement_amount_for_vehicle_including_box:'',
        notes:'',
        dmemo_emi_per_vehicle:'',
        dmemo_emi_all_vehicle:'',     
    });

    const filterRelationalDropdowns = (searchVal, action) =>{

        if(action === 'lead_source'){
            const sourceInfo = allCloudLeadSources.filter((item) => item.source_name === searchVal);
            let sourceId = sourceInfo?.[0]?.source_id;
            if(sourceInfo?.[0]?.source_id === null) {
                sourceId = '';
            } 

            setDealerArr([]); 
            setSourcesNameArr([]);  
            if(sourceId !==''){ 
                const allDealerData = allDealerArr.filter((item) => item.allcloud_parent_id === sourceId);
                const allSourcesNameData = allSourcesNameArr.filter((item) => item.allcloud_parent_id === sourceId);

                setDealerArr(allDealerData); 
                setSourcesNameArr(allSourcesNameData); 
            }
        }

 
        if(action === 'CompanyRoleId'){
             setCentresFilteredArr([]); 
             
            if(searchVal !==''){ 
                 const filteredData = centresArr.filter((item) => item.branch_id === searchVal); 
                 setCentresFilteredArr(filteredData);  
            }
        }

        if(action === 'vehicleTypeId'){
             setVehicleMakeArr([]); 
             setVehicleClassArr([]);  
             setVehicleClassVariantArr([]);    
            if(searchVal !==''){ 
                 const filteredData = allVehicleMakeArr.filter((item) => item.allcloud_parent_id === searchVal); 
                 setVehicleMakeArr(filteredData);  
            }
        }

        if(action === 'vehicleMakeId'){
             setVehicleClassArr([]);  
            if(searchVal !==''){ 
                 const filteredData = allVehicleClassArr.filter((item) => item.allcloud_parent_id === searchVal); 
                 setVehicleClassArr(filteredData);  
            }
        }

        if(action === 'vehicleClassId'){
             setVehicleClassVariantArr([]);  
            if(searchVal !==''){ 
                 const filteredData = allVehicleClassVariantArr.filter((item) => item.allcloud_parent_id === searchVal); 
                 setVehicleClassVariantArr(filteredData); 
            }
        } 
               
        
    };

    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.getUserModuleData(requestData);
        response.then((result) => {
            // console.log("Promise resolved -  lead list:", result);
            if (result.data.success === 1) {
                const permissionsData = result.data.data;
                setPermissions(permissionsData);
                const leadPermissions = permissionsData.find(permission => permission.module_name === 'Leads');
                const hasAddPermissions = leadPermissions?.add_permission;
                const hasEditPermissions = leadPermissions?.edit_permission;

                setAddModulePermissionStatus(hasAddPermissions);
                setEditModulePermissionStatus(hasEditPermissions);
                setUserHasPermission(id !== undefined ? hasEditPermissions : hasAddPermissions);

                if (Object.prototype.hasOwnProperty.call(result.data, 'user_info') && Object.prototype.hasOwnProperty.call(result.data.user_info[0], 'role_type') && result.data.user_info[0].role_type !== '') {
                    setUserRoleType(result.data.user_info[0].role_type);
                    // alert(result.data.user_info[0].role_type);
                    setLoggeInUserID(result.data.user_info[0].user_id);

                    setIsCrifUser(result.data.user_info[0].is_crif_user);
                }

            }
        }).catch((error) => {
            // console.error("Promise rejected -  lead list:", error);
        });

        setAssignedUser("");
        setSelectedAssignedGroup("");

    }, [setPermissions, setUserHasPermission, setAssignedUser, setSelectedAssignedGroup]);

    useEffect(() => {
        // check user is logged-in or not
        const authToken = localStorage.getItem('authToken');
        if (authToken === null) {
            navigate('/login');
        }

        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        actions.usersData(requestData, false);
        if (usersData.success) {
            setAllUsers(usersData.data);
        }
    }, []);

     
     const autoUpdateField = (fieldName, value, formName) => {

        if(formName === 'lead'){
            setFormLeadValues((formLeadValues) => ({
            ...formLeadValues,  
            [fieldName]: value,  
            }));
         }else if(formName === 'loan'){
            setFormLoanValues((formLoanValues) => ({
            ...formLoanValues,  
            [fieldName]: value,  
            })); 
            
        }else if(formName === 'PREEMI'){
            setFormPREEMIValues((formPREEMIValues) => ({
            ...formPREEMIValues,  
            [fieldName]: value,  
            }));            
        }else{
             setFormValues((formValues) => ({
            ...formValues,  
            [fieldName]: value,  
            }));
        }
    };  

    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.masterProfileData(requestData, false);
        response.then((result) => {
            // console.log("Promise resolved -  master profile data:", result); 
            if (result.data.success === 1) {
                const results = result.data.data.data;
                const resultArr = Object.keys(results).map((key) => results[key]);
                const filteredResultArr = resultArr.filter((item) => item.status === "1");
                const sortedResultArr = filteredResultArr.sort((a, b) =>
                    a.lead_profile_name.localeCompare(b.lead_profile_name)
                );
                setAllMasterProfiles(sortedResultArr);
            }
        }).catch((error) => {
            //  console.error("Promise rejected -  source data :", error); 
        });

        setAllStates([]);
        setAllAddressTypes([]);
        const objStates = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestDataStates = encryptData(objStates);
        const responseStates = actions.masterStatesData(requestDataStates, false);
        responseStates.then((result) => {
            // console.log("Promise resolved -  master profile data:", result); 
            if (result.data.success === 1) {
                const results = result.data.data.data;
                const resultArr = Object.keys(results).map((key) => results[key]);
                setAllStates(resultArr);

                const resultsAddressTypes = result.data.all_address_types.data;
                const resultAddressTypesArr = Object.keys(resultsAddressTypes).map((key) => resultsAddressTypes[key]);
                setAllAddressTypes(resultAddressTypesArr);
            }
        }).catch((error) => {
            //  console.error("Promise rejected -  source data :", error); 
        });

        setLoanTypeIdArr([]); 
        setDealerArr([]); 
        setSourcesNameArr([]);
        setCompanyRoleArr([]);
        setPurposeOfLoanArr([]); 
        setVehiclesTypeArr([]); 
        const decodedId = atob(id);      
        const objMasters = { 'start': '0', 'length': config.MAX_RECORDS , module: 'send_to_allcloud','lead_id': decodedId};
        const requestDataMasters = encryptData(objMasters);
        const responseMasters = actions.masterAllData(requestDataMasters, false);
        responseMasters.then((result) => {
            // console.log("Promise resolved -  master profile data:", result); 
            if (result.data.success === 1) {
                const results = result.data.data;

                const camDetails = results?.cam_details; 
                const jsonData = JSON.parse(camDetails); 
                setFormCAMValues(jsonData); 

                // console.log("000000000000000000000 resultArr = ",results)
                const loanTypeIdArrData = results.LoanTypeIdArr?.data || [];
                // console.log("000000000000000000000 loanTypeIdArrData = ",results.LoanTypeIdArr?.data || [])
                setLoanTypeIdArr(loanTypeIdArrData); 

                const dealerArrData = results.DealerArr?.data || [];
                setDealerArr(dealerArrData);  
                setAllDealerArr(dealerArrData);

                const sourcesNameArrData = results.SourcesNameArr?.data || [];
                setSourcesNameArr(sourcesNameArrData);
                setAllSourcesNameArr(sourcesNameArrData);

                const companyRoleArrData = results.CompanyRoleArr?.data || [];
                setCompanyRoleArr(companyRoleArrData);

                const centresArrData = results.CentresArr?.data || [];
                setCentresArr(centresArrData);

                const purposeOfLoanArrData = results.PurposeOfLoanArr?.data || [];
                setPurposeOfLoanArr(purposeOfLoanArrData);

                const vehiclesTypeArrData = results.VehiclesTypeArr?.data || [];
                setVehiclesTypeArr(vehiclesTypeArrData); 

                const vehicleMakeArrData = results.VehicleMakeArr?.data || [];
                setAllVehicleMakeArr(vehicleMakeArrData);

                 const vehicleClassArrData = results.VehicleClassArr?.data || [];
                setAllVehicleClassArr(vehicleClassArrData);

                const vehicleClassVariantArrData = results.VehicleClassVariantArr?.data || [];
                setAllVehicleClassVariantArr(vehicleClassVariantArrData); 

                
               // setTimeout(() => {
                     // autoUpdateField("LoanAmount", 1,'lead'); 

                     
                        
                        autoUpdateField("LoanAmount", jsonData?.irr_finance_amount,'lead');
                        autoUpdateField("LoanTenure", jsonData?.cam_loan_tenor_in_months,'lead');
                        autoUpdateField("CentreName", jsonData?.cam_location,'lead');
                        autoUpdateField("loan_category", "General",'lead');
                        autoUpdateField("ProductTypeId", "VehicleLoan",'lead');
                        autoUpdateField("lead_source", jsonData?.cam_source,'lead');
                        autoUpdateField("PurposeofLoan", "9",'lead');
                        autoUpdateField("LoanState", "0",'lead');
                        autoUpdateField("LoanTypeId", "0",'lead');
                        autoUpdateField("SubLoanTypeId", "0",'lead');
                        autoUpdateField("ComfortableEMI", "1",'lead');
                        autoUpdateField("AddressId", "0",'lead');
                        autoUpdateField("LoanSegmentId", "24",'lead');
                        autoUpdateField("vehicleTypeId", "20",'lead');
                        autoUpdateField("EmployerName", jsonData?.cam_sales_manager,'lead');
                        autoUpdateField("OrganizationName", jsonData?.cam_customer_name,'lead');
                        autoUpdateField("IncorporationDate", jsonData?.cam_dob,'lead');
                        autoUpdateField("IncorporationOrganizationType", jsonData?.cam_constitution,'lead');

                        autoUpdateField("AnnualProfit", "100000",'lead');
                        autoUpdateField("IncorporationDate", currentDate,'lead');
                        autoUpdateField("AnnualSalary", 100000,'lead');
                        autoUpdateField("JoiningDate", currentDate,'lead');

                         autoUpdateField("CompanyRoleId", "198",'lead');
                        autoUpdateField("lead_source_detail_id", "206",'lead');
                        autoUpdateField("scheme_id", "20",'lead');
 
 
                        autoUpdateField("AssetValue", jsonData?.cam_asset_cost,'loan');
                        autoUpdateField("SanctionAmount", jsonData?.cam_finance_value,'loan');
 

                        if(jsonData?.irr_finance_amount?.toString().trim() !==''){
                            setIsLoanAmountDisabled(true); 
                        }

                        if(jsonData?.cam_loan_tenor_in_months?.toString().trim() !==''){
                            setIsLoanTenureDisabled(true); 
                        }

                       // if(initialFormValues.loan_category !==''){
                             setIsLoanCategoryDisabled(true);
                       // }
                       // if(initialFormValues.ProductTypeId !==''){                       
                            setIsProductTypeDisabled(true); 
                       // } 
                        if(jsonData?.cam_sales_manager?.toString().trim() !==''){
                            setIsEmployerNameDisabled(true);
                        }

                        if(jsonData?.cam_asset_cost?.toString().trim() !==''){
                            setIsAssetValueDisabled(true);
                        }

                         if(jsonData?.cam_finance_value?.toString().trim() !==''){
                            setIsSanctionAmountDisabled(true);
                        }

                        

                        if(jsonData?.cam_source !== ''){                          
                            filterRelationalDropdowns(jsonData?.cam_source,'lead_source');                            
                             const isDropdownDisabledStatus = allCloudLeadSources.some(
                                (item) => item.source_name === jsonData?.cam_source
                                );
                            setIsDropdownDisabled(isDropdownDisabledStatus); 
                        }

                        const isPurposeOfLoandownDisabledStatus = purposeOfLoanArrData.some(
                                (item) => item.allcloud_id === "9"
                                ); 
                        setIsPurposeOfLoanDropdownDisabled(isPurposeOfLoandownDisabledStatus);

                        const isLoanTypeDropdownDisabledStatus = loanTypeIdArrData.some(
                                (item) => item.allcloud_id === "1"
                                ); 
                        setIsLoanTypeDropdownDisabled(isLoanTypeDropdownDisabledStatus); 
                        filterRelationalDropdowns("20",'vehicleTypeId');  
                         
              //  }, 500); 
 
            }
        }).catch((error) => {
           console.log("000000000000000000000 error  = ",error)
        });

    }, [setAllMasterProfiles, setAllStates,setLoanTypeIdArr, setDealerArr,setFormCAMValues]);


    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.allCloudSchemesData(requestData, false);
        response.then((result) => {
           if (result.data.success === 1) {
            const results = result.data.data.data;
            const resultArr = Object.keys(results).map((key) => results[key]);
            const filteredResultArr = resultArr.filter((item) => item.status === "1");
            const sortedResultArr = filteredResultArr.sort((a, b) =>
                a.scheme_name.localeCompare(b.scheme_name)
            );
            setAllCloudSchemes(sortedResultArr);
          }
        }).catch((error) => {
         });
    
    }, [setAllCloudSchemes]);

    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.allCloudLoanCategoriesData(requestData, false);
        response.then((result) => {
           if (result.data.success === 1) {
            const results = result.data.data.data;
            const resultArr = Object.keys(results).map((key) => results[key]);
            const filteredResultArr = resultArr.filter((item) => item.status === "1");
            const sortedResultArr = filteredResultArr.sort((a, b) =>
                a.category_name.localeCompare(b.category_name)
            );
            setAllCloudLoanCategories(sortedResultArr);
          }
        }).catch((error) => {
         });
    
    }, [setAllCloudLoanCategories]);

    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.allCloudLeadSourcesData(requestData, false);
        response.then((result) => {
           if (result.data.success === 1) {
            const results = result.data.data.data;
            const resultArr = Object.keys(results).map((key) => results[key]);
            const filteredResultArr = resultArr.filter((item) => item.status === "1");
            const sortedResultArr = filteredResultArr.sort((a, b) =>
                a.source_name.localeCompare(b.source_name)
            );
            setAllCloudLeadSources(sortedResultArr);
          }
        }).catch((error) => {
         });
    
    }, [setAllCloudLeadSources]);

    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.allCloudOrganizationTypesData(requestData, false);
        response.then((result) => {
          
           if (result.data.success === 1) {
            const results = result.data.data.data;
            const resultArr = Object.keys(results).map((key) => results[key]);
            const filteredResultArr = resultArr.filter((item) => item.status === "1");
            const sortedResultArr = filteredResultArr.sort((a, b) =>
                a.type_name.localeCompare(b.type_name)
            );
            setAllCloudOrganizationTypes(sortedResultArr);

            autoUpdateField("OrganizationType", "NA",'lead');
            autoUpdateField("IncorporationOrganizationType", "NA",'lead');
            
          }
        }).catch((error) => {
         });
    
    }, [setAllCloudOrganizationTypes]);

    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.allCloudProductTypesData(requestData, false);
        response.then((result) => {
          
           if (result.data.success === 1) {
            const results = result.data.data.data;
            const resultArr = Object.keys(results).map((key) => results[key]);
            const filteredResultArr = resultArr.filter((item) => item.status === "1");
            const sortedResultArr = filteredResultArr.sort((a, b) =>
                a.type_name.localeCompare(b.type_name)
            );
            setAllCloudProductTypes(sortedResultArr);
          }
        }).catch((error) => {
         });
    
    }, [setAllCloudProductTypes]);

    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.allCloudLpcTypesData(requestData, false);
        response.then((result) => {
          
           if (result.data.success === 1) {
            const results = result.data.data.data;
            const resultArr = Object.keys(results).map((key) => results[key]);
            const filteredResultArr = resultArr.filter((item) => item.status === "1");
            const sortedResultArr = filteredResultArr.sort((a, b) =>
                a.type_name.localeCompare(b.type_name)
            );
            setAllCloudLpcTypes(sortedResultArr);
          }
        }).catch((error) => {
         });
    
    }, [setAllCloudLpcTypes]);

    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.allCloudEmploymentTypesData(requestData, false);
        response.then((result) => {
          
           if (result.data.success === 1) {
            const results = result.data.data.data;
            const resultArr = Object.keys(results).map((key) => results[key]);
            const filteredResultArr = resultArr.filter((item) => item.status === "1");
            const sortedResultArr = filteredResultArr.sort((a, b) =>
                a.type_name.localeCompare(b.type_name)
            );
            setAllCloudEmploymentTypes(sortedResultArr);
          }
        }).catch((error) => {
         });
    
    }, [setAllCloudEmploymentTypes]);



    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.groupData(requestData, false);
        response.then((result) => {
            // console.log("Promise resolved -  groupData list:", result);
            if (result.data.data.success === 1) {
                const results = result.data.data.data;
                const resultArr = Object.keys(results).map((key) => results[key]);
                const filteredResultArr = resultArr.filter((item) => item.status === "1");
                const sortedResultArr = filteredResultArr.sort((a, b) =>
                    a.group_name.localeCompare(b.group_name)
                );
                setAllGroupData(sortedResultArr);
            }
        }).catch((error) => {
            console.error("Promise rejected -  lead list:", error);
        });

    }, [setAllGroupData]);


    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.allCloudLoanSegmentsData(requestData, false);
        response.then((result) => {
          
           if (result.data.success === 1) {
            
            const results = result.data.data.data;
            const resultArr = Object.keys(results).map((key) => results[key]);
            const filteredResultArr = resultArr.filter((item) => item.status === "1");
            const sortedResultArr = filteredResultArr.sort((a, b) =>
                a.LoanTypeId.localeCompare(b.LoanTypeId)
            );
            console.log("sortedResultArr = ", sortedResultArr);
            setAllCloudLoanSegments(sortedResultArr);

            const isLoanSegmentDropdownDisabledStatus = sortedResultArr.some(
                    (item) => item.LoanSegmentId === "24"
                    ); 
            setIsLoanSegmentDropdownDisabled(isLoanSegmentDropdownDisabledStatus);
 
           
          }
        }).catch((error) => {
         });
    
    }, [setAllCloudLoanSegments]);




    const fetchLeads = useCallback(() => {
        setShowLeadDetails(false);

        setShowNoteNoteByCredit("");
        setShowNote("");

        // console.log("fetchLeads calling ", id, showLeadDetails);
        if (urlLoanApplicationID !== undefined ) {
            const loanApplicationIDVal = atob(urlLoanApplicationID);            
            setLoanApplicationID(loanApplicationIDVal); 
        }

        if (enachid !== undefined) {
            const enachIdVal = atob(enachid); console.log('enach id-', enachIdVal);
            
            setEnachId(enachIdVal);
        }


        if (id !== undefined && !showLeadDetails) {
            const decodedId = atob(id);
            setLeadId(decodedId); 
            

            const obj = { 'start': '0', 'length': config.MAX_RECORDS, 'lead_id': decodedId ,  'loan_application_id': loanApplicationID, 'enach_registration_id': enachId };
            const requestData = encryptData(obj);
            const response = actions.leadInfo(requestData, false);
            response.then((result) => {
                // console.log("Promise resolved -  leadInfo:", result); 
                if (result.data.success === 1) {

                    const leadInfoData = result.data.data;

                    if ('data' in leadInfoData && leadInfoData.data.length > 0) {
                        setPageHeading(` AllCloud Information (${leadInfoData.data[0].name} - ${leadInfoData.data[0].mobile} )`);
                        setShowLeadDetails(true);
                        setLeadData(leadInfoData.data);
                        let panNumber = '';
                        if (Object.prototype.hasOwnProperty.call(leadInfoData.data[0], 'pancard_number') && leadInfoData.data[0].pan_number !== '' && leadInfoData.data[0].pancard_number !== null) {
                            panNumber = leadInfoData.data[0].pancard_number.replace(/"/g, '');
                        }

                        let adharNumber = '';
                        if (Object.prototype.hasOwnProperty.call(leadInfoData.data[0], 'adhar_number') && leadInfoData.data[0].adhar_number !== '' && leadInfoData.data[0].adhar_number !== null) {
                            adharNumber = leadInfoData.data[0].adhar_number.replace(/"/g, '');
                        }
 
                     
                         autoUpdateField("Postcode", leadInfoData.data?.[0].pin,'lead'); 
                         autoUpdateField("IncorporationPostcode", leadInfoData.data?.[0].pin,'lead'); 

                        if (Object.prototype.hasOwnProperty.call(leadInfoData.data[0], 'AllCloudCustomerInfo')) {
                            setAllCloudCustomerInfo(leadInfoData.data[0].AllCloudCustomerInfo);

                            if (leadInfoData.data[0].AllCloudCustomerInfo.length > 0) {
                                const initialFormValues = {
                                    phone_number: leadInfoData.data[0].mobile,
                                    customerType: leadInfoData.data[0].AllCloudCustomerInfo[0].customerType,
                                    credit_score: leadInfoData.data[0].AllCloudCustomerInfo[0].credit_score,
                                    remarks: leadInfoData.data[0].AllCloudCustomerInfo[0].remarks,
                                    caste: leadInfoData.data[0].AllCloudCustomerInfo[0].caste,
                                    contactreferencedto_name: leadInfoData.data[0].AllCloudCustomerInfo[0].contactreferencedto_name,
                                    contactreferencedto_contactnumber: leadInfoData.data[0].AllCloudCustomerInfo[0].contactreferencedto_contactnumber,
                                    contactreferencedto_town: leadInfoData.data[0].AllCloudCustomerInfo[0].contactreferencedto_town,
                                    contactreferencedto_address: leadInfoData.data[0].AllCloudCustomerInfo[0].contactreferencedto_address,
                                    contactreferencedto_area: leadInfoData.data[0].AllCloudCustomerInfo[0].contactreferencedto_area,
                                    contactreferencedto_postcode: leadInfoData.data[0].AllCloudCustomerInfo[0].contactreferencedto_postcode,
                                    customer_state: leadInfoData.data[0].AllCloudCustomerInfo[0].stateId,
                                    company_name: leadInfoData.data[0].AllCloudCustomerInfo[0].company_name,
                                    name_to_be_display:leadInfoData.data[0].AllCloudCustomerInfo[0].name_to_be_display,

                                };

                                setFormValues(initialFormValues);
                                setCustomerCreatedStatus(true);
                                setCustomerID(leadInfoData.data[0].AllCloudCustomerInfo[0].id);

                                if (Object.prototype.hasOwnProperty.call(leadInfoData.data[0].AllCloudCustomerInfo[0], 'allcloud_api_response')) {
                                    if(leadInfoData.data[0].AllCloudCustomerInfo[0].allcloud_api_response !==''){
                                         const allcloudApiData = JSON.parse(leadInfoData.data[0].AllCloudCustomerInfo[0].allcloud_api_response);

                                         if (Object.prototype.hasOwnProperty.call(allcloudApiData, 'CustomerId') && allcloudApiData.CustomerId !=='') {
                                            setAllCloudCustomerCreatedStatus(true);
                                            setAllCloudCustomerID(allcloudApiData.CustomerId);     
                                         } 

                                         if (Object.prototype.hasOwnProperty.call(allcloudApiData, 'CustomerDTO') && allcloudApiData.CustomerDTO !== '') {

                                            if (Object.prototype.hasOwnProperty.call(allcloudApiData.CustomerDTO, 'CustomerId') && allcloudApiData.CustomerDTO.CustomerId !== '') {
                                                setAllCloudCustomerCreatedStatus(true);
                                                setAllCloudCustomerID(allcloudApiData.CustomerDTO.CustomerId); 

                                               // alert(allcloudApiData.CustomerDTO.CustomerId);
                                            }
                                       }
                                    } 
                                    
                                }
                            }
                        }

                        if (Object.prototype.hasOwnProperty.call(leadInfoData.data[0], 'AllCloudCustomerLeadInfo')) {
                          
                            setAllCloudCustomerLeadInfo(leadInfoData.data[0].AllCloudCustomerLeadInfo);

                            if (leadInfoData.data[0].AllCloudCustomerLeadInfo.length > 0) {
                                    
                                 if(leadInfoData.data?.[0].AllCloudCustomerLeadInfo?.[0].lead_source !== ''){
                                    filterRelationalDropdowns(leadInfoData.data?.[0].AllCloudCustomerLeadInfo?.[0].lead_source,'lead_source'); 

                                    const isDropdownDisabledStatus = allCloudLeadSources.some(
                                        (item) => item.source_name === leadInfoData.data?.[0].AllCloudCustomerLeadInfo?.[0].lead_source
                                        );
                                    setIsDropdownDisabled(isDropdownDisabledStatus); 
                                }


                                
                                if(leadInfoData.data?.[0].AllCloudCustomerLeadInfo?.[0].CompanyRoleId !== ''){
                                    filterRelationalDropdowns(leadInfoData.data?.[0].AllCloudCustomerLeadInfo?.[0].CompanyRoleId,'CompanyRoleId');

                                    console.log("centresArr = ", centresArr);
                                   
                                    const filteredData = centresArr.filter((item) => item.branch_id === leadInfoData.data?.[0].AllCloudCustomerLeadInfo?.[0].CompanyRoleId); 
                                    setCentresFilteredArr(filteredData);  
                                }                                
                                

                                if(leadInfoData.data?.[0].AllCloudCustomerLeadInfo?.[0].vehicleTypeId !== ''){
                                    filterRelationalDropdowns(leadInfoData.data?.[0].AllCloudCustomerLeadInfo?.[0].vehicleTypeId,'vehicleTypeId');
                                   
                                    const filteredData = allVehicleMakeArr.filter((item) => item.allcloud_parent_id === leadInfoData.data?.[0].AllCloudCustomerLeadInfo?.[0].vehicleTypeId); 
                                    setVehicleMakeArr(filteredData);
                                    
                                }

                                if(leadInfoData.data?.[0].AllCloudCustomerLeadInfo?.[0].vehicleMakeId !== ''){ 
                                    filterRelationalDropdowns(leadInfoData.data?.[0].AllCloudCustomerLeadInfo?.[0].vehicleMakeId,'vehicleMakeId'); 

                                     
                                        const filteredData = allVehicleClassArr.filter((item) => item.allcloud_parent_id === leadInfoData.data?.[0].AllCloudCustomerLeadInfo?.[0].vehicleMakeId); 
                                        setVehicleClassArr(filteredData);  
                                     
                                }

                                 

                                if(leadInfoData.data?.[0].AllCloudCustomerLeadInfo?.[0].vehicleClassId !== ''){
                                    filterRelationalDropdowns(leadInfoData.data?.[0].AllCloudCustomerLeadInfo?.[0].vehicleClassId,'vehicleClassId'); 
                                }

                                 const initialFormValues = {
                                    CompanyRoleId: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].CompanyRoleId,
                                    LoanSegmentId: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].LoanSegmentId,
                                    PurposeofLoan: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].PurposeofLoan,

                                    LoanState: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].LoanState,
                                    LoanTypeId: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].LoanTypeId,
                                    SubLoanTypeId: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].SubLoanTypeId,
                                    ComfortableEMI: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].ComfortableEMI,
                                    AddressId: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].AddressId,

                                    ProductTypeId: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].ProductTypeId,
                                    loan_category: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].loan_category,
                                    lead_source: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].lead_source,
                                    DealerId: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].DealerId,
                                    lead_source_detail_id: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].lead_source_detail_id,
                                    scheme_id: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].scheme_id,
                                    mfgYear: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].mfgYear,

                                    vehicleTypeId: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].vehicleTypeId,
                                    vehicleClassId:leadInfoData.data[0].AllCloudCustomerLeadInfo[0].vehicleClassId,
                                    vehicleMakeId:leadInfoData.data[0].AllCloudCustomerLeadInfo[0].vehicleMakeId,
                                    vehicleClassVariantId:leadInfoData.data[0].AllCloudCustomerLeadInfo[0].vehicleClassVariantId,
                                    EmployerName: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].EmployerName,
                                    AnnualSalary: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].AnnualSalary,
                                    JoiningDate: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].JoiningDate,
                                    Designation: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].Designation,
                                    OrganizationType: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].OrganizationType,
                                    Sector: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].Sector,
                                    AddressLine1: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].AddressLine1,
                                    Area: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].Area,
                                    Town: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].Town,
                                    Postcode: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].Postcode,
                                    OrganizationName: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].OrganizationName,
                                    AnnualProfit: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].AnnualProfit,
                                    IncorporationDate: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].IncorporationDate,
                                    IncorporationOrganizationType: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].IncorporationOrganizationType,
                                    AnnualIncome: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].AnnualIncome,
                                    IncorporationAddressLine1: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].IncorporationAddressLine1,
                                    IncorporationArea: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].IncorporationArea,
                                    IncorporationTown: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].IncorporationTown,
                                    IncorporationPostcode: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].IncorporationPostcode,
                                    IOTCompanyName: leadInfoData.data[0].AllCloudCustomerLeadInfo[0].IOTCompanyName,
                                    BatteryCompanyName : leadInfoData.data[0].AllCloudCustomerLeadInfo[0].BatteryCompanyName,
                                    LoanAmount : leadInfoData.data[0].AllCloudCustomerLeadInfo[0].LoanAmount,
                                    LoanTenure : leadInfoData.data[0].AllCloudCustomerLeadInfo[0].LoanTenure,
                                    CentreName : leadInfoData.data[0].AllCloudCustomerLeadInfo[0].CentreName,
                                    DownPayment : leadInfoData.data[0].AllCloudCustomerLeadInfo[0].DownPayment  
                                     
                                }; 

                                
 
                                setAllCloudLocalLeadID(leadInfoData.data[0].AllCloudCustomerLeadInfo[0].id);                                 
                                setFormLeadValues(initialFormValues);                                

                                const allcloudApiData = (leadInfoData?.data?.[0]?.AllCloudCustomerLeadInfo?.[0]?.allcloud_api_response !=='') ? JSON.parse(leadInfoData?.data?.[0]?.AllCloudCustomerLeadInfo?.[0]?.allcloud_api_response) : [];
                                
                                if (Object.prototype.hasOwnProperty.call(allcloudApiData, 'LeadDetailId') && allcloudApiData.LeadDetailId !=='') {
                                    setAllCloudLeadID(allcloudApiData.LeadDetailId); 
                                    setCustomerLeadCreatedStatus(true);   
                                }
                                const preEmiDetailsData = (leadInfoData?.data?.[0]?.AllCloudCustomerLeadInfo?.[0]?.preEmiDetails !=='') ? JSON.parse(leadInfoData.data[0].AllCloudCustomerLeadInfo[0].preEmiDetails) : []; 
 
                                  if (Object.prototype.hasOwnProperty.call(preEmiDetailsData, 'pre_emi_start_date') && preEmiDetailsData.pre_emi_start_date !=='') {
                                        const initialFormValues = {                                    
                                           pre_emi_start_date: preEmiDetailsData.pre_emi_start_date,
                                           pre_emi_end_date: preEmiDetailsData.pre_emi_end_date,
                                           pre_emi: preEmiDetailsData.pre_emi,
                                           total_down_payment_by_customer: preEmiDetailsData.total_down_payment_by_customer,
                                           pre_emi_type: preEmiDetailsData.pre_emi_type,
                                           disbursement_amount_for_vehicle_including_box: preEmiDetailsData.disbursement_amount_for_vehicle_including_box,
                                           dmemo_emi_per_vehicle: preEmiDetailsData?.dmemo_emi_per_vehicle || 0,
                                           dmemo_emi_all_vehicle:preEmiDetailsData?.dmemo_emi_all_vehicle || 0,    
                                        };
                                        setFormPREEMIValues(initialFormValues);

                                        if(preEmiDetailsData.CamAutoApprovedStatus !== undefined){
                                         setCamAutoApprovedStatus(preEmiDetailsData.CamAutoApprovedStatus);
                                        }
                                         setSanctionRecordExistStatus(preEmiDetailsData.SanctionRecordExist);
                                         setDORecordExistStatus(preEmiDetailsData.DORecordExist);

                                    }else{
                                        const initialFormValues = {                                    
                                           pre_emi_start_date: formCAMValues.dmemo_pre_emi_start_date,
                                           pre_emi_end_date: formCAMValues.dmemo_pre_emi_end_date,
                                           pre_emi: formCAMValues.dmemo_pre_emi,
                                           total_down_payment_by_customer: formCAMValues.dmemo_total_down_payment_by_customer,
                                           pre_emi_type: formCAMValues.dmemo_pre_emi_type,
                                           disbursement_amount_for_vehicle_including_box: formCAMValues.dmemo_disbursement_amount_for_vehicle_including_box,
                                           dmemo_emi_per_vehicle: formCAMValues?.dmemo_emi_per_vehicle || 0,
                                           dmemo_emi_all_vehicle:formCAMValues?.dmemo_emi_all_vehicle || 0, 
                                        };
                                        setFormPREEMIValues(initialFormValues);
                                        setDefaultFieldsValues(initialFormValues);

                                    }
                               
                             } 
                        } 
 
                        
                        if (Object.prototype.hasOwnProperty.call(leadInfoData.data[0], 'AllCloudCustomerLoanInfo')) {
                            setAllCloudCustomerLoanInfo(leadInfoData.data[0].AllCloudCustomerLoanInfo);

                            if (leadInfoData.data[0].AllCloudCustomerLoanInfo.length > 0) {
                                const initialFormValues = {                                    
                                    CompanyRoleId: leadInfoData.data[0].AllCloudCustomerLoanInfo[0].CompanyRoleId,
                                    LoanStateForPL: leadInfoData.data[0].AllCloudCustomerLoanInfo[0].LoanStateForPL,
                                    SanctionAmount: leadInfoData.data[0].AllCloudCustomerLoanInfo[0].SanctionAmount,
                                    AssetValue: leadInfoData.data[0].AllCloudCustomerLoanInfo[0].AssetValue,
                                    UpFrontFee: leadInfoData.data[0].AllCloudCustomerLoanInfo[0].UpFrontFee, 
                                 
                                    EMIStartDate: leadInfoData.data[0].AllCloudCustomerLoanInfo[0].EMIStartDate, 
                                    InstallmentTypeId: leadInfoData.data[0].AllCloudCustomerLoanInfo[0].InstallmentTypeId,
                                    ModeOfRePaymentId: leadInfoData.data[0].AllCloudCustomerLoanInfo[0].ModeOfRePaymentId,
                                    YearlyInterest: leadInfoData.data[0].AllCloudCustomerLoanInfo[0].YearlyInterest,
                                    StartDate: leadInfoData.data[0].AllCloudCustomerLoanInfo[0].StartDate,
                                    LPC: leadInfoData.data[0].AllCloudCustomerLoanInfo[0].LPC,
                                    LPCType: leadInfoData.data[0].AllCloudCustomerLoanInfo[0].LPCType,
                                    EmploymentType: leadInfoData.data[0].AllCloudCustomerLoanInfo[0].EmploymentType,
                                    LoanAgreementNo: leadInfoData.data[0].AllCloudCustomerLoanInfo[0]?.AgreementNo 

                                };
                                setFormLoanValues(initialFormValues);
                               

                                const allcloudApiData = JSON.parse(leadInfoData.data[0].AllCloudCustomerLoanInfo[0].allcloud_api_response);

                        //             if (Object.prototype.hasOwnProperty.call(allcloudApiData, 'LeadDetailId') && allcloudApiData.LeadDetailId !=='') {
                        //                 setAllCloudLoanLeadID(allcloudApiData.LeadDetailId); 
                        //                 setCustomerLoanCreatedStatus(true);
                        //             } 
                        //      }
                        // }
                                         if (Object.prototype.hasOwnProperty.call(allcloudApiData, 'LeadDetailId') && allcloudApiData.LeadDetailId !=='') {
                                          setAllCloudLoanLeadID(allcloudApiData.LeadDetailId); 
                                          setCustomerLoanCreatedStatus(true);
                                       } 

                                    if (Object.prototype.hasOwnProperty.call(leadInfoData.data[0].AllCloudCustomerLoanInfo[0], 'enach_id') && leadInfoData.data[0].AllCloudCustomerLoanInfo[0].enach_id !== '' && leadInfoData.data[0].AllCloudCustomerLoanInfo[0].enach_id !== null) {
                                        setLoanEnachId(leadInfoData.data[0].AllCloudCustomerLoanInfo[0].enach_id);
                                    }
                             }
                        }
 

                       

                    }
                }
            }).catch((error) => {
                // console.error("Promise rejected -  leadInfo :", error);
            });
        }

        if (id === undefined) {
            const initialFormValues = {
                customerType: 'Individual',
                phone_number: '',
                credit_score: '',
                remarks: '',
                caste: '',
                contactreferencedto_name: '',
                contactreferencedto_contactnumber: '',
                contactreferencedto_town: '',
                contactreferencedto_address: '',
                contactreferencedto_area: '',
                contactreferencedto_postcode: '',
                company_name:'',
                customer_state:'',
                name_to_be_display :''
            };

            setFormValues(initialFormValues);

            setShowLeadDetails(false);
            setPageHeading('Add Details');
            setLeadId('');
            setPanDetailsInfoGender('');
            setPanDetailsInfoAddress('');
            setLeadPanDetails('');
            setShowNote('');
            setSelectedAssignedGroup('');
            setAssignedUser('');
        }
        
    }, [id, setValue, setShowLeadDetails, setPageHeading, setSelectedAssignedGroup, setAssignedUser, setAllLeadActivity,setAllCloudCustomerID,centresArr,sourcesNameArr,setCamAutoApprovedStatus]);

    

    useEffect(() => { 
         setTimeout(() => {
                 fetchLeads(); 
         }, 1500); 
    }, [fetchLeads]);

    useEffect(() => {
    if (id === undefined) return;

    const decodedId = atob(id);

    const params = { 'lead_id': decodedId };
    const requestData = encryptData(params);

    fetch(`${config.API_BASE_URL}get_lead_fleet_status`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: requestData,
    })
        .then((response) => response.json())
        .then((result) => {
            if (result && result.success === 1 && result.is_fleet === true) {
                setIsFleetCase(true);
            } else {
                setIsFleetCase(false);
            }
        })
        .catch((error) => {
            setIsFleetCase(false);
        });
}, [id]);

    const handleSubmitCustomerInfo = (data) => {

        if(formValues.customerType === '') {
            formValues.customerType = "Individual";
        }

        if(formValues.customer_state < 1) {
            formValues.customer_state = "";
        }

        if(formValues.company_name === undefined){
            formValues.company_name = '';
        }
 
        let phoneNumber = ''; let leadIdNumber = '';
        if (Object.prototype.hasOwnProperty.call(leadData[0], 'mobile')) {
            phoneNumber = leadData[0].mobile;
            leadIdNumber = leadData[0].id;
        }

        if (phoneNumber === '') {
            toast.error("Lead information is incomplete.", {
                position: "top-right",
            });

        }else if(formValues.customerType === ''){
            toast.error("Customer Type is required.", {
                position: "top-right",
            });

        }else if(formValues.customerType === 'Non-Individual' && ( formValues.company_name ===''  || formValues.company_name === undefined )){    
            toast.error("Company is required.", {
                position: "top-right",
            });
        }else if(formValues.customer_state === ''){
            toast.error("State is required.", {
                position: "top-right",
            });    
        } else {


            const params = { 'phone_number': phoneNumber, 'customerType': formValues.customerType, 'credit_score': formValues.credit_score, 'remarks': formValues.remarks, 'caste': formValues.caste, 'contactreferencedto_name': formValues.contactreferencedto_name, 'contactreferencedto_contactnumber': formValues.contactreferencedto_contactnumber, 'contactreferencedto_town': formValues.contactreferencedto_town, 'contactreferencedto_address': formValues.contactreferencedto_address, 'contactreferencedto_area': formValues.contactreferencedto_area, 'contactreferencedto_postcode': formValues.contactreferencedto_postcode, 'lead_id': leadIdNumber,  'loan_application_id': loanApplicationID , 'stateId': formValues.customer_state,"company_name":formValues.company_name, "name_to_be_display" :formValues.name_to_be_display, 'enach_registration_id': enachId};

             
            console.log("params : ", params);

            const requestData = encryptData(params);
            const response = actions.addEditLeadAllCloudCustomer(requestData);

            response.then((result) => {
                // console.log("Promise resolved - add/edit lead form:", result); 
                if (result.data.success === 1) {
                    toast.success(result.data.message, {
                        position: "top-right",
                    });
                    setTimeout(() => {
                        fetchLeads();
                        const encodedId = btoa(leadId); 

                        if(urlLoanApplicationID !== undefined && enachid !== undefined){
                            navigate(`/dashboard/send-to-allcloud/${encodedId}/${urlLoanApplicationID}/${enachid}`); 
                        }else{
                            navigate(`/dashboard/send-to-allcloud/${encodedId}`);
                        }  

                    }, 1000);
                } else {
                    toast.error(result.data.message, {
                        position: "top-right",
                    });
                }
            }).catch((error) => {
                // console.error("Promise rejected - add/edit lead form:", error);
                toast.error(error, {
                    position: "top-right",
                });
            });
        }
    };

    const handleSubmitLeadInfo = (data) => {
        

        let leadIdNumber = '';
        if (Object.prototype.hasOwnProperty.call(leadData[0], 'id')) {
             leadIdNumber = leadData[0].id;
        }

        if (leadIdNumber === '') {
            toast.error("Lead id required", {
                position: "top-right",
            });
        } else { 

           if(formLeadValues.loan_category ===''){
            formLeadValues.loan_category = 'General';
           }  

            const params = { 'CompanyRoleId': formLeadValues.CompanyRoleId,'LoanSegmentId': formLeadValues.LoanSegmentId,'PurposeofLoan': formLeadValues.PurposeofLoan ,'LoanState': formLeadValues.LoanState,'LoanTypeId': formLeadValues.LoanTypeId,'SubLoanTypeId': formLeadValues.SubLoanTypeId,'ComfortableEMI': formLeadValues.ComfortableEMI,'AddressId': formLeadValues.AddressId, 'ProductTypeId': formLeadValues.ProductTypeId, 'loan_category': formLeadValues.loan_category, 'lead_source': formLeadValues.lead_source,'DealerId': formLeadValues.DealerId, 'lead_source_detail_id': formLeadValues.lead_source_detail_id, 'scheme_id': formLeadValues.scheme_id, 'mfgYear': formLeadValues.mfgYear, 'vehicleTypeId' :formLeadValues.vehicleTypeId,'vehicleClassId':formLeadValues.vehicleClassId,'vehicleMakeId':formLeadValues.vehicleMakeId,'vehicleClassVariantId':formLeadValues.vehicleClassVariantId,'EmployerName': formLeadValues.EmployerName,'AnnualSalary': formLeadValues.AnnualSalary,'JoiningDate': formLeadValues.JoiningDate, 'Designation': formLeadValues.Designation,'OrganizationType': formLeadValues.OrganizationType,'Sector': formLeadValues.Sector,'AddressLine1': formLeadValues.AddressLine1,'Area': formLeadValues.Area,'Town': formLeadValues.Town,'Postcode': formLeadValues.Postcode,'OrganizationName': formLeadValues.OrganizationName,'AnnualProfit': formLeadValues.AnnualProfit,'IncorporationDate': formLeadValues.IncorporationDate,'IncorporationOrganizationType': formLeadValues.IncorporationOrganizationType,'AnnualIncome': formLeadValues.AnnualIncome,'IncorporationAddressLine1': formLeadValues.IncorporationAddressLine1,'IncorporationArea': formLeadValues.IncorporationArea,'IncorporationTown': formLeadValues.IncorporationTown,'IncorporationPostcode': formLeadValues.IncorporationPostcode,'IOTCompanyName': formLeadValues.IOTCompanyName,'BatteryCompanyName': formLeadValues.BatteryCompanyName,'LoanAmount': formLeadValues.LoanAmount,'LoanTenure': formLeadValues.LoanTenure,'CentreName': formLeadValues.CentreName,'DownPayment': formLeadValues.DownPayment, 'lead_id': leadIdNumber,'customer_id' : customerID,  'loan_application_id': loanApplicationID, 'enach_registration_id': enachId };


            console.log("params : ", params);

            const requestData = encryptData(params);
            const response = actions.addEditAllCloudCustomerLead(requestData);

            response.then((result) => {
                // console.log("Promise resolved - add/edit lead form:", result); 
                if (result.data.success === 1) {
                    toast.success(result.data.message, {
                        position: "top-right",
                    });
                    setTimeout(() => {
                        fetchLeads();
                        const encodedId = btoa(leadId);
                       
                        if(urlLoanApplicationID !== undefined && enachid !== undefined){
                            navigate(`/dashboard/send-to-allcloud/${encodedId}/${urlLoanApplicationID}/${enachid}`); 
                        }else{
                            navigate(`/dashboard/send-to-allcloud/${encodedId}`);
                        }

                    }, 1000);
                } else {
                    toast.error(result.data.message, {
                        position: "top-right",
                    });
                }
            }).catch((error) => {
                // console.error("Promise rejected - add/edit lead form:", error);
                toast.error(error, {
                    position: "top-right",
                });
            });
        }

    };

    const handleSubmitLoanInfo = (data) => {
        

        let leadIdNumber = '';
        if (Object.prototype.hasOwnProperty.call(leadData[0], 'id')) {
             leadIdNumber = leadData[0].id;
        }

        if (leadIdNumber === '') {
            toast.error("Lead id required", {
                position: "top-right",
            });
        } else { 

           
            const params = { 'CompanyRoleId': formLoanValues.CompanyRoleId,'LoanStateForPL': formLoanValues.LoanStateForPL,'SanctionAmount': formLoanValues.SanctionAmount,'AssetValue': formLoanValues.AssetValue,'UpFrontFee': formLoanValues.UpFrontFee,'InstallmentTypeId': formLoanValues.InstallmentTypeId,'ModeOfRePaymentId': formLoanValues.ModeOfRePaymentId,'EMIStartDate': formLoanValues.EMIStartDate, 'YearlyInterest': formLoanValues.YearlyInterest, 'StartDate': formLoanValues.StartDate,'LPC':formLoanValues.LPC,'LPCType':formLoanValues.LPCType,'EmploymentType':formLoanValues.EmploymentType, 'lead_id': leadIdNumber,'customer_id' : customerID ,  'loan_application_id': loanApplicationID,'allcloud_local_lead_id': allCloudLocalLeadID, 'enach_registration_id': enachId};

            console.log("params : ", params);
            const requestData = encryptData(params);
            const response = actions.addEditAllCloudCustomerLoan(requestData);

            response.then((result) => {
                // console.log("Promise resolved - add/edit lead form:", result); 
                if (result.data.success === 1) {
                    toast.success(result.data.message, {
                        position: "top-right",
                    });
                    setTimeout(() => {
                        fetchLeads();
                        const encodedId = btoa(leadId);
                        
                        if(urlLoanApplicationID !== undefined && enachid !== undefined){
                            navigate(`/dashboard/send-to-allcloud/${encodedId}/${urlLoanApplicationID}/${enachid}`); 
                        }else{
                            navigate(`/dashboard/send-to-allcloud/${encodedId}`);
                        }

                    }, 1000);
                } else {
                    toast.error(result.data.message, {
                        position: "top-right",
                    });
                }
            }).catch((error) => {
                // console.error("Promise rejected - add/edit lead form:", error);
                toast.error(error, {
                    position: "top-right",
                });
            });
        }

    };

    const submitFromModal = () => {
        if (openModal && formPREEMIValues.notes === '') {
            toast.error("Notes is required", {
                position: "top-right",
            });
        }else{ 
             handleSubmitPREEMIInfo();
        }
    };

    const handleSubmitPREEMIInfo = (data) => {
        let leadIdNumber = '';
        
        if (Object.prototype.hasOwnProperty.call(leadData[0], 'id')) {
             leadIdNumber = leadData[0].id;
        }

        if (leadIdNumber === '') {
            toast.error("Lead id required", {
                position: "top-right",
            });

        }else if( openModal && formPREEMIValues.notes === ''){
            toast.error("Notes is required", {
                position: "top-right",
            });
        } else { 

            let camReversalStatus = 'no';
            if(openModal && approveBtnAction === ''){
                camReversalStatus = 'yes';
            }
 
            const params = { 'preEmiDetails': formPREEMIValues, 'lead_id': leadIdNumber,'customer_id' : customerID,  'loan_application_id': loanApplicationID, 'brief' : 'preEmiUpdation', 'camReversalStatus' : camReversalStatus , 'api_calling_module' : approveBtnAction,"sendEmail" : sendEmailBtnAction, 'enach_registration_id': enachId};
 
            console.log("params : ", params);

            const requestData = encryptData(params);
            const response = actions.addEditAllCloudCustomerLead(requestData);

            response.then((result) => {
                // console.log("Promise resolved - add/edit lead form:", result);
                 setOpenModal(false); 
                if (result.data.success === 1) { 
                    
                    setApproveBtnAction('');
                    setOpenModal(false);
                    setSendEmailBtnAction(0);
                    
                    if (Object.prototype.hasOwnProperty.call(result?.data?.preEmiDetails, 'reverseRequest') && result?.data?.preEmiDetails.reverseRequest) {
                             setOpenModal(true);

                    }else{
                         toast.success(result.data.message, {
                            position: "top-right",
                        });

                        if(result?.data?.preEmiDetails?.CamAutoApprovedStatus !== undefined){
                            setCamAutoApprovedStatus(result?.data?.preEmiDetails?.CamAutoApprovedStatus);
                        }

                        setSanctionRecordExistStatus(result?.data?.preEmiDetails?.SanctionRecordExist);
                        setDORecordExistStatus(result?.data?.preEmiDetails?.DORecordExist);

                        setTimeout(() => {
                            fetchLeads();
                            const encodedId = btoa(leadId);
                            
                            if(urlLoanApplicationID !== undefined && enachid !== undefined){
                                navigate(`/dashboard/send-to-allcloud/${encodedId}/${urlLoanApplicationID}/${enachid}`); 
                            }else{
                                navigate(`/dashboard/send-to-allcloud/${encodedId}`);
                            }

                        }, 1000);
                    }
                } else {
                    toast.error(result.data.message, {
                        position: "top-right",
                    });
                }
            }).catch((error) => {
                // console.error("Promise rejected - add/edit lead form:", error);
                toast.error(error, {
                    position: "top-right",
                });
            });
        }

    };

    const handleClose = () => {
        setOpen(false);
    };


    const openHideCompanyFields = (customerType) => { 
        setCompanyDetailsStatus(customerType !== 'Individual');
    };
    
    const handleChange = (e) => {
        const { name, value } = e.target;
    
        setFormValues((prevValues) => {
            const updatedValues = { ...prevValues, [name]: value };
    
 
            if(e.target.name === 'customerType'){
                // Ensure the latest value is passed
                openHideCompanyFields(updatedValues.customerType);
            }
    
            return updatedValues;
        });
    };

     
    /* const openHideCompanyFields = () => {
        setCompanyDetailsStatus(false);
        alert(formValues.customerType);
        if(formValues.customerType !== 'Individual'){
            setCompanyDetailsStatus(true);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormValues({
            ...formValues,
            [name]: value,
        });

        openHideCompanyFields();

    }; */

    

    const handleLeadChange = (e) => {
        const { name, value } = e.target;

        setFormLeadValues({
            ...formLeadValues,
            [name]: value,
        }); 

        setFormLeadValues((prevValues) => {
            const updatedValues = { ...prevValues, [name]: value }; 

            if(e.target.name === 'lead_source'){
                  filterRelationalDropdowns(updatedValues.lead_source,'lead_source'); 
                  const isDropdownDisabledStatus = allCloudLeadSources.some(
                    (item) => item.source_name === updatedValues.lead_source
                    );
                 //  setIsDropdownDisabled(isDropdownDisabledStatus); 
            }

            if(e.target.name === 'CompanyRoleId'){
                  filterRelationalDropdowns(updatedValues.CompanyRoleId,'CompanyRoleId'); 
            }

            if(e.target.name === 'vehicleTypeId'){
                  filterRelationalDropdowns(updatedValues.vehicleTypeId,'vehicleTypeId'); 
            }

            if(e.target.name === 'vehicleMakeId'){
                  filterRelationalDropdowns(updatedValues.vehicleMakeId,'vehicleMakeId'); 
            }

             if(e.target.name === 'vehicleClassId'){
                  filterRelationalDropdowns(updatedValues.vehicleClassId,'vehicleClassId'); 
            }

            return updatedValues;
        });

        

       
    };

    const handleLoanChange = (e) => {
        const { name, value } = e.target;

        setFormLoanValues({
            ...formLoanValues,
            [name]: value,
        });

    };

    const roundNumber = (num) => {
        if (!num && num !== 0) return 0; 
        return Math.round(num);
    };

     function calculatePMT(rate, nper, pv,formData) {
        rate = rate / 100 / 12; // Convert annual interest rate to monthly
        let spliteEmi = 0;
        if(formData.dmemo_pre_emi_type === 'Merge with EMI'){
        const dmemoPreEmiAmount = formData?.dmemo_pre_emi || 0;
        const dmemoTenure = formData?.dmemo_tenure || 0; 
        spliteEmi = (dmemoTenure !== 0) ? dmemoPreEmiAmount / dmemoTenure : 0;

        // console.log("spliteEmi = ",spliteEmi);
        }
        let outPut = (pv * rate) / (1 - (1 + rate) ** -nper);

        outPut += Number(spliteEmi); 
        return roundNumber(outPut);
    }

    function calculateInterest(amount, rate, start, end) {
        const startDt = new Date(start);
        const endDt = new Date(end);
        // const daysDiff = (startDt - endDt) / (1000 * 60 * 60 * 24); // Convert milliseconds to days
        const daysDiff = (endDt - startDt) / (1000 * 60 * 60 * 24); // Convert milliseconds to days
    // console.log("daysDiff = ",daysDiff);
        
       //  const interest = Math.ceil((amount * rate / 100) / 360 * daysDiff); // Apply ROUNDUP
        const interest = Math.round((amount * rate / 100) / 360 * daysDiff); // Apply ROUNDUP

         // console.log("interest = ",interest);
        const output =  roundNumber(interest);
        return output; // Apply negative sign
    }

    
    const setDefaultFieldsValues = (data) => {

        let dmemoTotalPreEmi = 0; 
        const startDate = data.pre_emi_start_date;
        const endDate = data.pre_emi_end_date;
        const loanAmount = parseFloat(formCAMValues.dmemo_loan_amount) || 0;
        const interestRate = parseFloat(formCAMValues.dmemo_irr) || 0;
        if( startDate !== '' && endDate !== '' ) {
          dmemoTotalPreEmi = calculateInterest(loanAmount, interestRate, startDate, endDate);
        }

        
        autoUpdateField("pre_emi", dmemoTotalPreEmi.toFixed(2),'PREEMI');

        const dmemoProcessingFeeIncluding = formCAMValues.dmemo_processing_fee_including_gst;
        const dmemoInsuranceByCfpl = parseFloat(formCAMValues.dmemo_insurance_by_cfpl) || 0;
        const dmemoDealerSubvention = parseFloat(formCAMValues.dmemo_dealer_subvention) || 0;

        let dmemoTotalDisbursementAmountForVehicleIncludingBox = loanAmount - dmemoProcessingFeeIncluding - dmemoInsuranceByCfpl - dmemoDealerSubvention;

        if (data?.pre_emi_type === "Upfront Collection" || data?.pre_emi_type === undefined) {
          dmemoTotalDisbursementAmountForVehicleIncludingBox -= Number(dmemoTotalPreEmi) || 0;
        }

        if (formCAMValues?.dmemo_kli_amount_type === "Upfront Collection" || formCAMValues?.dmemo_kli_amount_type === undefined) {
          dmemoTotalDisbursementAmountForVehicleIncludingBox -= Number(formCAMValues?.dmemo_kli_amount) || 0;
        }else if (formCAMValues?.dmemo_kli_amount_type === "Funded with LA" ) {
          dmemoTotalDisbursementAmountForVehicleIncludingBox -= Number(formCAMValues?.dmemo_kli_amount) || 0;
        }

      
        dmemoTotalDisbursementAmountForVehicleIncludingBox -= Number(formCAMValues?.cam_file_charges) || 0; 
         
        autoUpdateField("disbursement_amount_for_vehicle_including_box", dmemoTotalDisbursementAmountForVehicleIncludingBox.toFixed(2),'PREEMI');

        /* 
         Section :  Total down payment by Customer ( Incuding PF and Other Charges) - START here  
         */  
         const irrTotalAssetPrice = parseFloat(formCAMValues.irr_total_asset_price) || 0;
         const dmemoLoanAmount = parseFloat(formCAMValues.dmemo_loan_amount) || 0;
         const dmemoNoOfAsset = parseFloat(formCAMValues.dmemo_no_of_asset) || 0;

        let dmemoTotalDownPaymentByCustomer =
        (irrTotalAssetPrice * dmemoNoOfAsset) - dmemoLoanAmount ;

        if (formCAMValues?.dmemo_file_charge_type === "Upfront Collection" || formCAMValues?.dmemo_file_charge_type === undefined) {
        dmemoTotalDownPaymentByCustomer += Number(formCAMValues?.cam_file_charges) || 0;
        }

        if (formCAMValues?.dmemo_processing_fee_including_gst_type === "Upfront Collection" || formCAMValues?.dmemo_processing_fee_including_gst_type === undefined) {
        dmemoTotalDownPaymentByCustomer += Number(dmemoProcessingFeeIncluding) || 0;
        }


        if (data?.pre_emi_type === "Upfront Collection" || data?.pre_emi_type === undefined) {
            dmemoTotalDownPaymentByCustomer += Number(dmemoTotalPreEmi) || 0;
        } 
        
        if (formCAMValues?.dmemo_kli_amount_type === "Upfront Collection" || formCAMValues?.dmemo_kli_amount_type === undefined) {
            dmemoTotalDownPaymentByCustomer += Number(formCAMValues?.dmemo_kli_amount) || 0;
        } 
    
        const totalDownPayment  = dmemoTotalDownPaymentByCustomer;
        autoUpdateField("total_down_payment_by_customer", totalDownPayment.toFixed(2),'PREEMI');


        const dmemoFundingPerVehicle2 = formCAMValues.dmemo_funding_per_vehicle || 0;  
        const  loanTerm  =  formCAMValues?.dmemo_tenure || 0;

        const updatedFormCAMValues = {
            ...formCAMValues,
            dmemo_pre_emi: dmemoTotalPreEmi.toFixed(2),
            dmemo_pre_emi_type: data?.pre_emi_type
            };

            setFormCAMValues(updatedFormCAMValues);
        
        const dmemoEmiPerVehicle = calculatePMT(interestRate, loanTerm, dmemoFundingPerVehicle2,updatedFormCAMValues).toFixed(2);
        
        autoUpdateField("dmemo_emi_per_vehicle", dmemoEmiPerVehicle,'PREEMI');

        const dmemoTotalEmiAllVehicle =   dmemoEmiPerVehicle * dmemoNoOfAsset; 
        autoUpdateField("dmemo_emi_all_vehicle", dmemoTotalEmiAllVehicle.toFixed(2),'PREEMI');

        console.log("loanAmount = ",loanAmount);
        console.log("interestRate = ",interestRate);
        console.log("startDate = ",startDate);
        console.log("endDate = ",endDate);
        console.log("00000000000000 dmemoTotalPreEmi = ",dmemoTotalPreEmi);
        console.log("111111 dmemoEmiPerVehicle = ",dmemoEmiPerVehicle);
        console.log("22222 dmemoNoOfAsset = ",dmemoNoOfAsset);
        console.log("formCAMValues = ",formCAMValues); 
        
        /* 
            Section :  Total down payment by Customer ( Incuding PF and Other Charges) - END here  
        */  
    };

    const handlePREEMIChange = (e) => {
            const { name, value } = e.target;

            const updatedValues = {
                ...formPREEMIValues,
                [name]: value,
            };

            setFormPREEMIValues(updatedValues);
            setDefaultFieldsValues(updatedValues);
    };


    // if (!userHasPermission) {
    //     // Redirect or render an access denied message
    //     return <AccessDenied />;
    // }

        
    const showLoanSubmitButton =
        allCloudLoanLeadID === '' ||
        (
            isFleetCase === true &&
            enachId !== '' && enachId !== undefined && enachId !== null &&
            loanEnachId !== '' && loanEnachId !== undefined && loanEnachId !== null &&
            String(enachId).trim() !== String(loanEnachId).trim()
        );

    if (!userHasPermission) {
        // Redirect or render an access denied message
        return <AccessDenied />;
    }

    return (
        <>
            <Helmet>
                <title> AllCloud Information | Ckers </title>
            </Helmet>
            <style>{`
                @keyframes fleetCaseBlink {
                    0%, 100% { opacity: 1; }
                    50% { opacity: 0.25; }
                }
                .fleet-case-blink {
                    display: inline-block;
                    font-size: 22px;
                    margin-right: 79px;
                    font-weight: 800;
                    color: #36b180e0;
                    animation: fleetCaseBlink 1s infinite;
                }
            `}</style>
            <Container>
                {/* <div className='row align-items-center'>
                    <div className='col-md-6'>
                        <Typography variant="h4" sx={{ mb: 5 }}>
                            {pageHeading}
                        </Typography>
                    </div>
                </div> */}

                <div className='row align-items-center'>
                    <div className='col-md-6'>
                        <Typography variant="h4" sx={{ mb: 5 }}>
                            {pageHeading}
                        </Typography>
                    </div>
                    <div className='col-md-6 text-end'>
                        {isFleetCase && (
                            <span className="fleet-case-blink">Fleet Case</span>
                        )}
                    </div>
                </div>

                <div id='main-wrap' className='mb-5'>


                    <div className="tab-content show " id="pills-tabContent">
                        <div className="tab-pane fade show active" id="pills-lead-info" role="tabpanel" aria-labelledby="pills-lead-info-tab" tabIndex="0">

                            <div className="tab-content" id="pills-tabContent">
                                <div className="tab-pane fade show active" id="pills-basic-info" role="tabpanel" aria-labelledby="pills-basic-info-tab" tabIndex="0">
                                    <div className="accordion first-level" id="accordionLI">
                                        <div className="accordion-item">
                                            <h2 className="accordion-header">
                                                <button className={customerCreatedStatus ? "accordion-button bg-green" : "accordion-button "} type="button" data-bs-toggle="collapse" data-bs-target="#LI-1" aria-expanded="true" aria-controls="LI-1" role="tab" aria-selected={leadId === '' ? "true" : "false"} disabled={leadId === ''}>
                                                    Customer
                                                </button>
                                            </h2>
                                            <div id="LI-1" className="accordion-collapse collapse show "
                                                data-bs-parent="#accordionLI">
                                                <div className="accordion-body p-md-3 px-2 pt-2 pb-4">

                                                    <form onSubmit={handleSubmit(handleSubmitCustomerInfo)}>
                                                        <div className='row'>

                                                            <div className='col-md-12 bg-skyblue- '>

                                                                <div className='row'>


                                                                  <div className="col-md-4 d-none-">
                                                                        <div className="form-group">
                                                                            <label htmlFor="customerType">
                                                                                <span>Customer Type <a style={{ color: "red" }}>*</a></span>
                                                                                <select id="customerType" name="customerType" className="form-select"  {...register('customerType')}
                                                                                    value={formValues.customerType}
                                                                                    onChange={handleChange}>
                                                                                    <option value="Individual">Individual</option>
                                                                                    <option value="Non-Individual">Non-Individual</option>
                                                                                </select>
                                                                            </label>
                                                                        </div>
                                                                    </div>

                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="customer_state">
                                                                <span>Select State<a style={{ color: "red" }}>*</a></span>
 
                                                                <select
                                                                        id='customer_state'
                                                                        name='customer_state'
                                                                        className="form-select"
                                                                        {...register('customer_state')}
                                                                        value={formValues.customer_state}
                                                                        onChange={handleChange} 
                                                                    >
                                                                        <option value=''>Select select</option>
                                                                        {allStates.map((option) => (
                                                                            <option value={option.id}>
                                                                                {option.state_name}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                            </label>
                                                        </div>
                                                    </div> 
                                                
                                                { companyDetailsStatus && (
                                                    <>
                                                        <div className='col-md-4 d-none-'>
                                                            <div className='form-group'>
                                                                <label htmlFor="company_name">
                                                                    <span>Company Name<a style={{ color: "red" }}>*</a></span>
                                                                    <input
                                                                        type='text'
                                                                        id='company_name '
                                                                        name='company_name'
                                                                        className='form-control'
                                                                        {...register('company_name')}
                                                                        value={formValues.company_name}
                                                                        onChange={handleChange}

                                                                    />
                                                                </label>

                                                            </div>
                                                        </div>
                                                    </>

                                                )}

<div className='col-md-4'>
    <div className='form-group'>
        <label htmlFor="name_to_be_display">
            <span>Name to be display in Allcloud</span>
            <input
                type='text'
                id='name_to_be_display '
                name='name_to_be_display'
                className='form-control'
                {...register('name_to_be_display')}
                value={formValues.name_to_be_display}
                onChange={handleChange}

            />
        </label>

    </div>
</div>


                                                                    <h6 className='mb-3 mt-3 d-none'>Credit Bureau Audit DTO</h6>
                                                                    <div className='col-md-4 d-none'>
                                                                        <div className='form-group'>
                                                                            <label htmlFor="credit_score">
                                                                                <span>Credit Score</span>
                                                                                <input
                                                                                    type='number'
                                                                                    min="0"
                                                                                    max="1000"
                                                                                    id='credit_score '
                                                                                    name='credit_score'
                                                                                    className='form-control'
                                                                                    {...register('credit_score')}
                                                                                    value={formValues.credit_score}
                                                                                    onChange={handleChange}

                                                                                />
                                                                            </label>

                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-4 d-none">
                                                                        <div className="form-group">
                                                                            <label htmlFor="caste">
                                                                                <span>Caste </span>
                                                                                <select id="caste" name="caste" className="form-select"  {...register('caste')}
                                                                                    value={formValues.caste}
                                                                                    onChange={handleChange}>
                                                                                    <option value="">Please select</option>
                                                                                    <option value="OC">OC</option>
                                                                                    <option value="BC">BC</option>
                                                                                    <option value="ScheduledCaste">ScheduledCaste</option>
                                                                                    <option value="ScheduledTribes">ScheduledTribes</option>
                                                                                    <option value="OBC">OBC</option>
                                                                                    <option value="General">General</option>
                                                                                    <option value="Minority">Minority</option>
                                                                                    <option value="Other">Other</option>
                                                                                    <option value="EconomicallyWeaker">EconomicallyWeaker</option>
                                                                                </select>
                                                                            </label>
                                                                        </div>
                                                                    </div>

                                                                    <div className='col-md-12  mb-3 d-none'>
                                                                        <div className='form-group'>
                                                                            <label htmlFor="remarks">
                                                                                <span>Remarks</span>
                                                                                <textarea
                                                                                    id='remarks '
                                                                                    name='remarks'
                                                                                    className='form-control'
                                                                                    {...register('remarks')}
                                                                                    value={formValues.remarks}
                                                                                    onChange={handleChange}

                                                                                />
                                                                            </label>
                                                                        </div>
                                                                    </div>

                                                                    <hr className="d-none" />

                                                                    <h6 className='mb-3 mt-3- d-none'>Contact Reference DTO</h6>

                                                                    <div className='col-md-4 d-none'>
                                                                        <div className='form-group'>
                                                                            <label htmlFor="contactreferencedto_name">
                                                                                <span>Name </span>
                                                                                <input
                                                                                    type='text'
                                                                                    id='contactreferencedto_name'
                                                                                    name='contactreferencedto_name'
                                                                                    className='form-control'
                                                                                    {...register('contactreferencedto_name')}
                                                                                    value={formValues.contactreferencedto_name}
                                                                                    onChange={handleChange}

                                                                                />
                                                                            </label>

                                                                        </div>
                                                                    </div>

                                                                    <div className='col-md-4 d-none'>
                                                                        <div className='form-group'>
                                                                            <label htmlFor="contactreferencedto_contactnumber">
                                                                                <span>Contact Number</span>
                                                                                <input
                                                                                    type='tel'
                                                                                    id='contactreferencedto_contactnumber'
                                                                                    name='contactreferencedto_contactnumber'
                                                                                    className='form-control'
                                                                                    {...register('contactreferencedto_contactnumber')}
                                                                                    value={formValues.contactreferencedto_contactnumber}
                                                                                    onChange={handleChange}

                                                                                />
                                                                            </label>

                                                                        </div>
                                                                    </div>

                                                                    <div className='col-md-4 d-none'>
                                                                        <div className='form-group'>
                                                                            <label htmlFor="contactreferencedto_town">
                                                                                <span>Town</span>
                                                                                <input
                                                                                    type='text'
                                                                                    id='contactreferencedto_town'
                                                                                    name='contactreferencedto_town'
                                                                                    className='form-control'
                                                                                    {...register('contactreferencedto_town')}
                                                                                    value={formValues.contactreferencedto_town}
                                                                                    onChange={handleChange}

                                                                                />
                                                                            </label>
                                                                        </div>
                                                                    </div>



                                                                    <div className='col-md-4 d-none'>
                                                                        <div className='form-group'>
                                                                            <label htmlFor="contactreferencedto_address">
                                                                                <span>Address</span>
                                                                                <input
                                                                                    type='text'
                                                                                    id='contactreferencedto_address'
                                                                                    name='contactreferencedto_address'
                                                                                    className='form-control'
                                                                                    {...register('contactreferencedto_address')}
                                                                                    value={formValues.contactreferencedto_address}
                                                                                    onChange={handleChange}

                                                                                />
                                                                            </label>
                                                                        </div>
                                                                    </div>

                                                                    <div className='col-md-4 d-none'>
                                                                        <div className='form-group'>
                                                                            <label htmlFor="contactreferencedto_area">
                                                                                <span>Area</span>
                                                                                <input
                                                                                    type='text'
                                                                                    id='contactreferencedto_area'
                                                                                    name='contactreferencedto_area'
                                                                                    className='form-control'
                                                                                    {...register('contactreferencedto_area')}
                                                                                    value={formValues.contactreferencedto_area}
                                                                                    onChange={handleChange}

                                                                                />
                                                                            </label>
                                                                        </div>
                                                                    </div>


                                                                    <div className='col-md-4  mb-3 d-none'>
                                                                        <div className='form-group'>
                                                                            <label htmlFor="contactreferencedto_postcode">
                                                                                <span>Postcode</span>
                                                                                <input
                                                                                    type='number'
                                                                                    id='contactreferencedto_postcode'
                                                                                    name='contactreferencedto_postcode'
                                                                                    className='form-control'
                                                                                    {...register('contactreferencedto_postcode')}
                                                                                    value={formValues.contactreferencedto_postcode}
                                                                                    onChange={handleChange}

                                                                                />
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>


                                                            <hr className="d-none"/>
                                                           

                                                            {allCloudCustomerID === '' && (
                                                            <>
                                                                 <div className='col-md-12 mt-2'>
                                                                <div className='form-group mb-2 float-right'>
                                                                    <button className="btn btn-primary"> Create Customer </button>
                                                                </div>
                                                            </div>
                                                            </>
                                                            )}

                                                        {allCloudCustomerID !== '' && (
                                                            <>
                                                            <div className='col-md-12 mt-2'>
                                                                <div className='form-group mb-2 float-right text-success'>
                                                                    <b>Customer ID #{allCloudCustomerID}</b>
                                                                </div>
                                                            </div>
                                                            </>
                                                         )}

                                                            <div className='col-md-12 mt-2 d-none'>
                                                                <div className='form-group mb-2 float-right'>
                                                                    <button className="btn btn-primary"> Create Customer </button>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item">
                                            <h2 className="accordion-header">
                                                <button  className={customerLeadCreatedStatus ? "accordion-button collapsed bg-green" : "accordion-button collapsed "} type="button" data-bs-toggle="collapse" data-bs-target="#LI-2" aria-expanded="true" aria-controls="LI-2" role="tab" aria-selected={allCloudCustomerID === '' ? "true" : "false"} disabled={allCloudCustomerID === ''}>
                                                    Make Lead
                                                </button>
                                            </h2>
                                            <div id="LI-2" className="accordion-collapse collapse" data-bs-parent="#accordionLI">
                                                <div className="accordion-body p-md-3 px-2 pt-2 pb-4">

                                                    <form onSubmit={handleSubmit(handleSubmitLeadInfo)}>
                                                        <div className='row'>

                                                            <div className='col-md-12 bg-skyblue- '>

                                                                <div className='row'>



<h6 className='mb-3 mt-3'>Lead Information</h6>




<div className='col-md-3'>
    <div className='form-group'>
        <label htmlFor="LoanAmount">
            <span title={formLeadValues.LoanAmount}>Loan Amount  </span>
            <input
                type='number'                
                id='LoanAmount'
                name='LoanAmount'
                className=  {isLoanAmountDisabled ? 'form-control disabled' : 'form-control'}
                {...register('LoanAmount')}
                value={formLeadValues.LoanAmount}
                readOnly = {isLoanAmountDisabled}
                onChange={handleLeadChange}                                
            />
        </label>                        
    </div>
</div>

<div className='col-md-3'>
    <div className='form-group'>
        <label htmlFor="LoanTenure">
            <span>Loan Tenure  </span>
            <input
                type='number'                
                id='LoanTenure'
                name='LoanTenure'
                className=  {isLoanTenureDisabled ? 'form-control disabled' : 'form-control'}
                {...register('LoanTenure')}
                value={formLeadValues.LoanTenure}
                readOnly = {isLoanTenureDisabled}
                onChange={handleLeadChange}                                
            />
        </label>                        
    </div>
</div>

 <div className='col-md-3'>
                        <div className='form-group'>
                            <label htmlFor="CompanyRoleId">
                                <span title="Company Role Id">Branch  </span>
                                
                                 <select
                                        id='CompanyRoleId'
                                        name='CompanyRoleId'
                                        className="form-select"
                                        {...register('CompanyRoleId')}
                                        value={formLeadValues.CompanyRoleId}
                                        onChange={handleLeadChange} 
                                    >
                                        <option value=''>Select select</option>
                                        {companyRoleArr.map((option) => (
                                            <option value={option.allcloud_id}>
                                                {option.name}
                                            </option>
                                        ))}
                                    </select>
                            </label>                        
                        </div>
                    </div>

                    

<div className='col-md-3'>
    <div className='form-group'>
        <label htmlFor="CentreName">
            <span>Centre  </span>
            
             <select
                id='CentreName'
                name='CentreName'
                className="form-select"
                {...register('CentreName')}
                value={formLeadValues.CentreName}
                onChange={handleLeadChange} 
            >
                <option value=''>Select select</option>
                {centresFilteredArr.map((option) => (
                    <option value={option.name}>
                        {option.name}
                    </option>
                ))}
            </select>
        </label>                        
    </div>
</div>

<div className='col-md-4'>
    <div className='form-group'>
        <label htmlFor="DownPayment">
            <span>Down Payment  </span>
            <input
                type='number'                
                id='DownPayment'
                name='DownPayment'
                className='form-control'
                {...register('DownPayment')}
                value={formLeadValues.DownPayment}
                onChange={handleLeadChange}                                
            />
        </label>                        
    </div>
</div>

          
            <div className="col-md-4">
                <div className="form-group">
                    <label htmlFor="loan_category">
                        <span>Loan Category     </span> 
                        <select
                                id='loan_category'
                                name='loan_category'
                                className=  {isLoanCategoryDisabled ? 'form-select disabled' : 'form-select'}
                                {...register('loan_category')}
                                value={formLeadValues.loan_category}
                                onChange={handleLeadChange}                              
                                readOnly = {isLoanCategoryDisabled}
                            >
                                <option value=''>Select select</option>
                                {allCloudLoanCategories.map((option) => (
                                    <option value={option.category_name}>
                                        {option.category_name}
                                    </option>
                                ))}
                            </select>
                    </label>
                </div>
            </div>


           
            <div className="col-md-4">
                <div className="form-group">
                    <label htmlFor="lead_source">
                        <span>Source</span> 
                        <select
                                id='lead_source'
                                name='lead_source'
                                className=  {isDropdownDisabled ? 'form-select disabled' : 'form-select'}
                                {...register('lead_source')}
                                value={formLeadValues.lead_source}
                                onChange={handleLeadChange}
                                readOnly = {isDropdownDisabled} 
                            >
                                <option value=''>Select select</option>
                                {allCloudLeadSources.map((option) => (
                                    <option value={option.source_name}>
                                        {option.source_name}
                                    </option>
                                ))}
                            </select>
                    </label>
                </div>
            </div>

             <div className="col-md-4">
                <div className="form-group">
                    <label htmlFor="DealerId">
                        <span>Dealer Name</span>
                        
                        <select
                                id='DealerId'
                                name='DealerId'
                                className="form-select"
                                {...register('DealerId')}
                                value={formLeadValues.DealerId}
                                onChange={handleLeadChange} 
                            >
                                <option value=''>Select select</option>
                                {dealerArr.map((option) => (
                                    <option value={option.allcloud_id}>
                                        {option.name}
                                    </option>
                                ))}
                            </select>

                    </label>
                </div>
            </div>


                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="lead_source_detail_id">
                            <span>Source Name</span>
                             
                             <select
                                id='lead_source_detail_id'
                                name='lead_source_detail_id'
                                className="form-select"
                                {...register('lead_source_detail_id')}
                                value={formLeadValues.lead_source_detail_id}
                                onChange={handleLeadChange} 
                            >
                                <option value=''>Select select</option>
                                {sourcesNameArr.map((option) => (
                                    <option value={option.allcloud_id}>
                                        {option.name}
                                    </option>
                                ))}
                            </select>
                        </label>
                       
                    </div>
                </div>


                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="scheme_id">
                            <span>Scheme Id</span>
                             
                             <select
                                id='scheme_id'
                                name='scheme_id'
                                className="form-select"
                                {...register('scheme_id')}
                                value={formLeadValues.scheme_id}
                                onChange={handleLeadChange} 
                            >
                                <option value=''>Select Scheme</option>
                                {allCloudSchemes.map((option) => (
                                    <option value={option.scheme_id}>
                                        {option.scheme_name}
                                    </option>
                                ))}
                            </select>
                        </label>
                        
                    </div>
                </div>

                <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="ProductTypeId">
                                <span>Product Type</span>
                                <select
                                    id='ProductTypeId'
                                    name='ProductTypeId'
                                    className=  {isProductTypeDisabled ? 'form-select disabled' : 'form-select'}     
                                    {...register('ProductTypeId')}
                                    value={formLeadValues.ProductTypeId}
                                    onChange={handleLeadChange}
                                    readOnly = {isProductTypeDisabled}
                                >
                                    <option value=''>Select select</option>
                                    {allCloudProductTypes.map((option) => (
                                        <option value={option.type_name}>
                                            {option.type_name}
                                        </option>
                                    ))}
                                </select>
                            </label>
                        </div>
                    </div>
 
                   


                   
                    <div className='col-md-4'>
                        <div className='form-group'>
                            <label htmlFor="PurposeofLoan">
                                <span>Purpose of Loan  </span>
                               
                                <select
                                        id='PurposeofLoan'
                                        name='PurposeofLoan'
                                        className=  {isPurposeOfLoanDropdownDisabled ? 'form-select disabled' : 'form-select'}    
                                        {...register('PurposeofLoan')}
                                        value={formLeadValues.PurposeofLoan}
                                        onChange={handleLeadChange} 
                                        readOnly = {isPurposeOfLoanDropdownDisabled} 
                                    >
                                        <option value=''>Select select</option>
                                        {purposeOfLoanArr.map((option) => (
                                            <option value={option.allcloud_id}>
                                                {option.name}
                                            </option>
                                        ))}
                                    </select>
                            </label>                        
                        </div>
                    </div>

                    <div className='col-md-4 d-nones'>
                        <div className='form-group'>
                            <label htmlFor="LoanState">
                                <span>Loan State  </span>
                                <input
                                    type='number'                
                                    id='LoanState'
                                    name='LoanState'
                                    className=  {formLeadValues.LoanState !== '' ? 'form-control disabled' : 'form-control'}
                                    {...register('LoanState')}
                                    value={formLeadValues.LoanState}
                                    onChange={handleLeadChange} 
                                    readOnly = {formLeadValues.LoanState !==''}                                
                                />
                            </label>                        
                        </div>
                    </div>
					
					<div className='col-md-4'>
                        <div className='form-group'>
                            <label htmlFor="LoanTypeId">
                                <span>Loan Type</span>
                              
                                 <select
                                    id='LoanTypeId'
                                    name='LoanTypeId'
                                    className=  {isLoanTypeDropdownDisabled ? 'form-select disabled-' : 'form-select'}
                                    {...register('LoanTypeId')}
                                    value={formLeadValues.LoanTypeId}
                                    onChange={handleLeadChange}
                                   // readOnly = {isLoanTypeDropdownDisabled} 
                                >
                                    <option value=''>Select select</option>
                                    
                                   {loanTypeIdArr.map((option) => (
                                    <option key={option.id} value={option.allcloud_id}>
                                        {option.name}
                                    </option>
                                    ))}
                                </select>
                            </label>                        
                        </div>
                    </div>
					
					<div className='col-md-4'>
                        <div className='form-group'>
                            <label htmlFor="SubLoanTypeId">
                                <span>Sub Loan Type Id</span>
                                <input
                                    type='number'                
                                    id='SubLoanTypeId'
                                    name='SubLoanTypeId'
                                    className=  {formLeadValues.SubLoanTypeId !== '' ? 'form-control disabled' : 'form-control'}
                                    {...register('SubLoanTypeId')}
                                    value={formLeadValues.SubLoanTypeId}
                                    onChange={handleLeadChange}
                                    readOnly = {formLeadValues.SubLoanTypeId !==''}                                  
                                />
                            </label>                        
                        </div>
                    </div>
					
					<div className='col-md-4'>
                        <div className='form-group'>
                            <label htmlFor="ComfortableEMI">
                                <span>Comfortable EMI  </span>
                                <input
                                    type='number'                
                                    id='ComfortableEMI'
                                    name='ComfortableEMI'
                                    className=  {formLeadValues.ComfortableEMI !== '' ? 'form-control disabled' : 'form-control'}
                                    {...register('ComfortableEMI')}
                                    value={formLeadValues.ComfortableEMI}
                                    onChange={handleLeadChange} 
                                    readOnly = {formLeadValues.ComfortableEMI !==''}                                 
                                />
                            </label>                        
                        </div>
                    </div>

                    <div className='col-md-4 d-none-'>
                        <div className='form-group'>
                            <label htmlFor="AddressId">
                                <span>Address Id </span>
                                <input
                                    type='number'                
                                    id='AddressId'
                                    name='AddressId'
                                    className=  {formLeadValues.AddressId !== '' ? 'form-control disabled' : 'form-control'}
                                    {...register('AddressId')}
                                    value={formLeadValues.AddressId}
                                    onChange={handleLeadChange} 
                                    readOnly = {formLeadValues.AddressId !==''}                                
                                />
                            </label>                        
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="LoanSegmentId">
                                <span>Loan Segment Id </span>
                                <select
                                    id='LoanSegmentId'
                                    name='LoanSegmentId'
                                    className=  {isLoanSegmentDropdownDisabled ? 'form-select disabled-' : 'form-select'}
                                    {...register('LoanSegmentId')}
                                    value={formLeadValues.LoanSegmentId}
                                    onChange={handleLeadChange} 
                                   /* readOnly = {isLoanSegmentDropdownDisabled}  */
                                >
                                    <option value=''>Select select</option>
                                    
                                    {allCloudLoanSegments.map((option) => (
                                        <option value={option.LoanSegmentId}>
                                            {option.LoanTypeId} - {option.SubLoanTypeId}
                                        </option>
                                    ))}
                                </select>
                            </label>
                        </div>
                    </div>
                    

                <hr />
                <h6 className='mb-3 mt-3'>VL Vehicle DTO   </h6>


                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="mfgYear">
                            <span>Mfg Year</span>
                            <input
                                type='number'                
                                id='mfgYear '
                                name='mfgYear'
                                className='form-control'
                                {...register('mfgYear')}
                                value={formLeadValues.mfgYear}
                                onChange={handleLeadChange}
                                
                            />
                        </label>                        
                    </div>
                </div>

                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="vehicleTypeId">
                            <span>Vehicle Type  </span>
                            
                            <select
                                    id='vehicleTypeId'
                                    name='vehicleTypeId'
                                    className="form-select"
                                    {...register('vehicleTypeId')}
                                    value={formLeadValues.vehicleTypeId}
                                    onChange={handleLeadChange} 
                                >
                                    <option value=''>Select select</option>
                                    {vehiclesTypeArr.map((option) => (
                                        <option value={option.allcloud_id}>
                                             {option.name}
                                        </option>
                                    ))}
                                </select>
                        </label>                        
                    </div>
                </div>

                 <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="vehicleMakeId"> 
                            <span>Make</span>
                           
                             <select
                                    id='vehicleMakeId'
                                    name='vehicleMakeId'
                                    className="form-select"
                                    {...register('vehicleMakeId')}
                                    value={formLeadValues.vehicleMakeId}
                                    onChange={handleLeadChange} 
                                >
                                    <option value=''>Select select</option>
                                    {vehicleMakeArr.map((option) => (
                                        <option value={option.allcloud_id}>
                                             {option.name}
                                        </option>
                                    ))}
                                </select>
                        </label>                        
                    </div>
                </div>

                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="vehicleClassId">
                            <span>Vehicle Class Id</span>
                            
                             <select
                                    id='vehicleClassId'
                                    name='vehicleClassId'
                                    className="form-select"
                                    {...register('vehicleClassId')}
                                    value={formLeadValues.vehicleClassId}
                                    onChange={handleLeadChange} 
                                >
                                    <option value=''>Select select</option>
                                    {vehicleClassArr.map((option) => (
                                        <option value={option.allcloud_id}>
                                             {option.name}
                                        </option>
                                    ))}
                                </select>
                        </label>                        
                    </div>
                </div>

               

                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="vehicleClassVariantId">
                            <span>Vehicle Class Variant Id</span>
                           

                            <select
                                    id='vehicleClassVariantId'
                                    name='vehicleClassVariantId'
                                    className="form-select"
                                    {...register('vehicleClassVariantId')}
                                    value={formLeadValues.vehicleClassVariantId}
                                    onChange={handleLeadChange} 
                                >
                                    <option value=''>Select select</option>
                                    {vehicleClassVariantArr.map((option) => (
                                        <option value={option.allcloud_id}>
                                             {option.name}
                                        </option>
                                    ))}
                                </select>
                        </label>                        
                    </div>
                </div> 




                <hr />
                <h6 className='mb-3 mt-3'>PL Salary Borrower DTO    </h6> 

                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="EmployerName">
                            <span>Employer Name</span>
                            <input
                                type='text'                
                                id='EmployerName'
                                name='EmployerName'
                                className=  {isEmployerNameDisabled ? 'form-control disabled' : 'form-control'} 
                                {...register('EmployerName')}
                                value={formLeadValues.EmployerName}
                                onChange={handleLeadChange}  
                                readOnly = {isEmployerNameDisabled}                                
                            />
                        </label>                        
                    </div>
                </div>  

                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="AnnualSalary">
                            <span>Annual Salary</span>
                            <input
                                type='number'                
                                id='AnnualSalary '
                                name='AnnualSalary'
                                className=  {formLeadValues.AnnualSalary !== '' ? 'form-control disabled' : 'form-control'} 
                                {...register('AnnualSalary')}
                                value={formLeadValues.AnnualSalary}
                                onChange={handleLeadChange}
                                readOnly = {formLeadValues.AnnualSalary !==''}                                 
                            />
                        </label>                        
                    </div>
                </div>  

                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="JoiningDate">
                            <span>Joining Date</span>
                            <input
                                type='date'                
                                id='JoiningDate'
                                name='JoiningDate'
                                className=  {formLeadValues.JoiningDate !== '' ? 'form-control disabled' : 'form-control'}                                 
                                {...register('JoiningDate')}
                                value={formLeadValues.JoiningDate}
                                onChange={handleLeadChange} 
                                readOnly = {formLeadValues.JoiningDate !==''}                                
                            />
                        </label>                        
                    </div>
                </div> 

                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="Designation">
                            <span>Designation </span>
                            <input
                                type='text'                
                                id='Designation'
                                name='Designation'
                                className=  {formLeadValues.Designation !== '' ? 'form-control disabled' : 'form-control'}  
                                {...register('Designation')}
                                value={formLeadValues.Designation}
                                onChange={handleLeadChange}
                                readOnly = {formLeadValues.Designation !==''}                                     
                            />
                        </label>                        
                    </div>
                </div>                

                 <div className="col-md-4">
                    <div className="form-group">
                        <label htmlFor="OrganizationType">
                            <span>Organization Type</span>                       
                            <select
                                    id='OrganizationType'
                                    name='OrganizationType'
                                    className="form-select"
                                    {...register('OrganizationType')}
                                    value={formLeadValues.OrganizationType}
                                    onChange={handleLeadChange} 
                                >
                                    <option value=''>Select select</option>
                                    {allCloudOrganizationTypes.map((option) => (
                                        <option value={option.type_name}>
                                            {option.type_name}
                                        </option>
                                    ))}
                                </select>
                        </label>
                    </div>
                </div> 

                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="Sector">
                            <span>Sector </span>
                            <input
                                type='text'                
                                id='Sector'
                                name='Sector'
                                 className=  {formLeadValues.Sector !== '' ? 'form-control disabled' : 'form-control'} 
                                {...register('Sector')}
                                value={formLeadValues.Sector}
                                onChange={handleLeadChange} 
                                readOnly = {formLeadValues.Sector !==''}                                   
                            />

                                 
                        </label>                        
                    </div>
                </div>  

                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="AddressLine1">
                            <span>Address Line 1 </span>
                            <input
                                type='text'                
                                id='AddressLine1'
                                name='AddressLine1'
                                className=  {formLeadValues.AddressLine1 !== '' ? 'form-control disabled' : 'form-control'}  
                                {...register('AddressLine1')}
                                value={formLeadValues.AddressLine1}
                                onChange={handleLeadChange} 
                                 readOnly = {formLeadValues.AddressLine1 !==''}                                 
                            /> 
                              
                        </label>                        
                    </div>
                </div>  

                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="Area ">
                            <span>Area  </span>
                            <input
                                type='text'                
                                id='Area'
                                name='Area'
                                className=  {formLeadValues.Area !== '' ? 'form-control disabled' : 'form-control'}
                                {...register('Area')}
                                value={formLeadValues.Area}
                                onChange={handleLeadChange}
                                 readOnly = {formLeadValues.Area !==''}                                
                            />
                              
                        </label>                        
                    </div>
                </div> 


                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="Town">
                            <span>Town  </span>
                            <input
                                type='text'                
                                id='Town'
                                name='Town'
                                className=  {formLeadValues.Town !== '' ? 'form-control disabled' : 'form-control'}
                                {...register('Town')}
                                value={formLeadValues.Town}
                                onChange={handleLeadChange}
                                readOnly = {formLeadValues.Town !==''}                                 
                            />
                            
                        </label>                        
                    </div>
                </div>  

                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="Postcode">
                            <span>Post code  </span>
                            <input
                                type='number'                
                                id='Postcode'
                                name='Postcode'
                                className=  {formLeadValues.Postcode !== '' ? 'form-control disabled' : 'form-control'}
                                {...register('Postcode')}
                                value={formLeadValues.Postcode}
                                onChange={handleLeadChange}
                                readOnly = {formLeadValues.Postcode !==''}                                 
                            />

                             
                        </label>                        
                    </div>
                </div>            


                <hr />
                <h6 className='mb-3 mt-3'>PL Organization Borrower DTO </h6> 

                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="OrganizationName">
                            <span>Organization Name  </span>
                            <input
                                type='text'                
                                id='OrganizationName '
                                name='OrganizationName'
                                className=   'form-control'
                                {...register('OrganizationName')}
                                value={formLeadValues.OrganizationName}
                                onChange={handleLeadChange}  
                            />
                             
                        </label>                        
                    </div>
                </div>  

                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="AnnualProfit">
                            <span>Annual Profit</span>
                            <input
                                type='number'                
                                id='AnnualProfit '
                                name='AnnualProfit'
                                className=  {formLeadValues.AnnualProfit !== '' ? 'form-control disabled' : 'form-control'} 
                                {...register('AnnualProfit')}
                                value={formLeadValues.AnnualProfit}
                                onChange={handleLeadChange}
                                readOnly = {formLeadValues.AnnualProfit !==''}                                 
                            />
                        </label>                        
                    </div>
                </div>  

                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="IncorporationDate">
                            <span>Incorporation Date</span>
                            <input
                                type='date'                
                                id='IncorporationDate'
                                name='IncorporationDate'
                                className=  {formLeadValues.IncorporationDate !== '' ? 'form-control disabled' : 'form-control'}
                                {...register('IncorporationDate')}
                                value={formLeadValues.IncorporationDate}
                                onChange={handleLeadChange}
                                readOnly = {formLeadValues.IncorporationDate !==''}                                
                            />
                        </label>                        
                    </div>
                </div> 

                           

                 <div className="col-md-4">
                    <div className="form-group">
                        <label htmlFor="IncorporationOrganizationType">
                            <span>Organization Type</span>                       
                            <select
                                    id='IncorporationOrganizationType'
                                    name='IncorporationOrganizationType'
                                    className="form-select"
                                    {...register('IncorporationOrganizationType')}
                                    value={formLeadValues.IncorporationOrganizationType}
                                    onChange={handleLeadChange} 
                                >
                                    <option value=''>Select select</option>
                                    {allCloudOrganizationTypes.map((option) => (
                                        <option value={option.type_name}>
                                            {option.type_name}
                                        </option>
                                    ))}
                                </select>
                        </label>
                    </div>
                </div> 

                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="AnnualIncome">
                            <span>Annual Income  </span>
                            <input
                                type='number'                
                                id='AnnualIncome'
                                name='AnnualIncome'
                                className='form-control'
                                {...register('AnnualIncome')}
                                value={formLeadValues.AnnualIncome}
                                onChange={handleLeadChange}                                
                            />
                        </label>                        
                    </div>
                </div>  

                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="IncorporationAddressLine1">
                            <span>Address Line 1 </span>
                            <input
                                type='text'                
                                id='IncorporationAddressLine1'
                                name='IncorporationAddressLine1'
                                className=  {formLeadValues.IncorporationAddressLine1 !== '' ? 'form-control disabled' : 'form-control'}
                                {...register('IncorporationAddressLine1')}
                                value={formLeadValues.IncorporationAddressLine1}
                                onChange={handleLeadChange}
                                readOnly = {formLeadValues.IncorporationAddressLine1 !==''}                               
                            /> 
                        </label>                        
                    </div>
                </div>  

                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="IncorporationArea ">
                            <span>Area  </span>
                            <input
                                type='text'                
                                id='IncorporationArea'
                                name='IncorporationArea'
                               className=  {formLeadValues.IncorporationArea !== '' ? 'form-control disabled' : 'form-control'}
                                {...register('IncorporationArea')}
                                value={formLeadValues.IncorporationArea}
                                onChange={handleLeadChange} 
                                readOnly = {formLeadValues.IncorporationArea !==''}                               
                            /> 
                        </label>                        
                    </div>
                </div> 


                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="IncorporationTown">
                            <span>Town  </span>
                            <input
                                type='text'                
                                id='IncorporationTown'
                                name='IncorporationTown'
                                className=  {formLeadValues.IncorporationTown !== '' ? 'form-control disabled' : 'form-control'}
                                {...register('IncorporationTown')}
                                value={formLeadValues.IncorporationTown}
                                onChange={handleLeadChange} 
                                readOnly = {formLeadValues.IncorporationTown !==''}                               
                            />

                           
                        </label>                        
                    </div>
                </div>  

                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="IncorporationPostcode">
                            <span>Post code  </span>
                            <input
                                type='number'                
                                id='IncorporationPostcode'
                                name='IncorporationPostcode'
                                className='form-control'
                                {...register('IncorporationPostcode')}
                                value={formLeadValues.IncorporationPostcode}
                                onChange={handleLeadChange}                                
                            />
                        </label>                        
                    </div>
                </div> 

                <hr />
                <h6 className='mb-3 mt-3'>IOT Details </h6> 

                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="IOTCompanyName">
                            <span>IOT Company Name  </span>
                            <input
                                type='text'                
                                id='IOTCompanyName '
                                name='IOTCompanyName'
                                className='form-control'
                                {...register('IOTCompanyName')}
                                value={formLeadValues.IOTCompanyName}
                                onChange={handleLeadChange}                                
                            />
                        </label>                        
                    </div>
                </div>  

                <hr />
                <h6 className='mb-3 mt-3'>Battery Details </h6> 

                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="BatteryCompanyName">
                            <span>Battery Company Name  </span>
                            <input
                                type='text'                
                                id='BatteryCompanyName '
                                name='BatteryCompanyName'
                                className='form-control'
                                {...register('BatteryCompanyName')}
                                value={formLeadValues.BatteryCompanyName}
                                onChange={handleLeadChange}                                
                            />
                        </label>                        
                    </div>
                </div>  



                                                                
                                                                </div>
                                                            </div>


                                                            <hr />
                                                            
                                                        
                                            

                                                            
                                            {allCloudLeadID === '' && (
                                                <>
                                                        <div className='col-md-12 mt-2'>
                                                        <div className='form-group mb-2 float-right'>
                                                            <button className="btn btn-primary"> Save </button>
                                                        </div>
                                                        </div>
                                                </>
                                                )}

                                            {allCloudLeadID !== '' && (
                                                <>
                                                <div className='col-md-12 mt-2'>
                                                    <div className='form-group mb-2 float-right text-success'>
                                                        <b>Lead ID #{allCloudLeadID}</b>
                                                    </div>
                                                </div>
                                                </>
                                                )}
                                                           

                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item">
                                            <h2 className="accordion-header">
                                                <button  className={customerLoanCreatedStatus ? "accordion-button collapsed bg-green" : "accordion-button collapsed "}  type="button" data-bs-toggle="collapse" data-bs-target="#LI-3" aria-expanded="true" aria-controls="LI-3" role="tab" aria-selected={allCloudCustomerID === '' ? "true" : "false"} disabled={allCloudCustomerID === ''}>
                                                    Loan
                                                </button>
                                            </h2>
                <div id="LI-3" className="accordion-collapse collapse" data-bs-parent="#accordionLI">
                    <div className="accordion-body p-md-3 px-2 pt-2 pb-4">
                   <div className='row'>

                     <div className='col-md-8 bg-skyblue- ' >
                   
                    <form onSubmit={handleSubmit(handleSubmitLoanInfo)}>
                            <div className='row'>
                                <div className='col-md-12 bg-skyblue- '>
                                    <div className='row'>
                                        
                                      

                                  

                    <div className='col-md-4'>
                        <div className='form-group'>
                            <label htmlFor="AssetValue">
                                <span title={`${enachId}`}>Asset Value</span>
                                <input
                                    type='text'                
                                    id='AssetValue'
                                    name='AssetValue'
                                     className=  {isAssetValueDisabled ? 'form-control disabled' : 'form-control'}
                                    {...register('AssetValue')}
                                    value={formLoanValues.AssetValue}
                                    onChange={handleLoanChange} 
                                    readOnly = {isAssetValueDisabled}                               
                                />
                                
                            </label>                        
                        </div>
                    </div> 

                    <div className='col-md-4'>
                        <div className='form-group'>
                            <label htmlFor="UpFrontFee">
                                <span>Up Front Fee</span>
                                <input
                                    type='text'                
                                    id='UpFrontFee'
                                    name='UpFrontFee'
                                    className='form-control'
                                    {...register('UpFrontFee')}
                                    value={formLoanValues.UpFrontFee}
                                    onChange={handleLoanChange}                                
                                />
                            </label>                        
                        </div>
                    </div> 


                
                <h6 className='mb-3 mt-3'>Lead Finance DTO    </h6> 
               
                 
                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="SanctionAmount">
                            <span>Sanction Amount</span>
                            <input
                                type='text'                
                                id='SanctionAmount'
                                name='SanctionAmount'
                                className=  {isSanctionAmountDisabled ? 'form-control disabled' : 'form-control'}
                                {...register('SanctionAmount')}
                                value={formLoanValues.SanctionAmount}
                                onChange={handleLoanChange}
                                readOnly = {isSanctionAmountDisabled}                                
                            />

                            
                                     
                        </label>                        
                    </div>
                </div> 
               
                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="StartDate">
                            <span>Start Date</span>
                            <input
                                type='date'                
                                id='StartDate'
                                name='StartDate'
                                className='form-control'
                                {...register('StartDate')}
                                value={formLoanValues.StartDate}
                                onChange={handleLoanChange}                                
                            />
                        </label>                        
                    </div>
                </div> 

                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="EMIStartDate">
                            <span>EMI Start Date</span>
                            
                            <input
                                type='date'                
                                id='EMIStartDate'
                                name='EMIStartDate'
                                className='form-control'
                                {...register('EMIStartDate')}
                                value={formLoanValues.EMIStartDate}
                                onChange={handleLoanChange}                                
                            />
                        </label>                        
                    </div>
                </div> 

                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="InstallmentTypeId">
                            <span>Installment Type</span>
                            <input
                                type='text'                
                                id='InstallmentTypeId'
                                name='InstallmentTypeId'
                                className='form-control'
                                {...register('InstallmentTypeId')}
                                value={formLoanValues.InstallmentTypeId}
                                onChange={handleLoanChange}                                
                            />
                        </label>                        
                    </div>
                </div> 

                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="ModeOfRePaymentId">
                            <span>Mode Of RePayment</span>
                            <input
                                type='text'                
                                id='ModeOfRePaymentId'
                                name='ModeOfRePaymentId'
                                className='form-control'
                                {...register('ModeOfRePaymentId')}
                                value={formLoanValues.ModeOfRePaymentId}
                                onChange={handleLoanChange}                                
                            />
                        </label>                        
                    </div>
                </div> 

                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="LoanStateForPL">
                            <span>Loan State ForPL</span>
                            <input
                                type='text'                
                                id='LoanStateForPL'
                                name='LoanStateForPL'
                                className='form-control'
                                {...register('LoanStateForPL')}
                                value={formLoanValues.LoanStateForPL}
                                onChange={handleLoanChange}                                
                            />
                        </label>                        
                    </div>
                </div> 

                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="YearlyInterest">
                            <span>Yearly Interest</span>
                            <input
                                type='number'                
                                id='YearlyInterest'
                                name='YearlyInterest'
                                className='form-control'
                                {...register('YearlyInterest')}
                                value={formLoanValues.YearlyInterest}
                                onChange={handleLoanChange}                                
                            />
                        </label>                        
                    </div>
                </div> 

               

                

                <div className='col-md-4'>
                    <div className='form-group'>
                        <label htmlFor="LPC">
                            <span>LPC</span>
                            <input
                                type='number'                
                                id='LPC'
                                name='LPC'
                                className='form-control'
                                {...register('LPC')}
                                value={formLoanValues.LPC}
                                onChange={handleLoanChange}                                
                            />
                        </label>                        
                    </div>
                </div> 

                
                 <div className="col-md-4">
                    <div className="form-group">
                        <label htmlFor="LPCType">
                            <span>LPC Type</span>
                            <select
                                id='LPCType'
                                name='LPCType'
                                className="form-select"
                                {...register('LPCType')}
                                value={formLoanValues.LPCType}
                                onChange={handleLoanChange} 
                            >
                                <option value=''>Select select</option>
                                {allCloudLpcTypes.map((option) => (
                                    <option value={option.type_name}>
                                        {option.type_name}
                                    </option>
                                ))}
                            </select>
                        </label>
                    </div>
                </div> 
                 
                <hr />
                <h6 className='mb-3 mt-3'>PL Asset Detail DTO   </h6> 
                    
                <div className="col-md-4">
                    <div className="form-group">
                        <label htmlFor="EmploymentType">
                            <span>Employment Type</span>
                            <select
                                id='EmploymentType'
                                name='EmploymentType'
                                className="form-select"
                                {...register('EmploymentType')}
                                value={formLoanValues.EmploymentType}
                                onChange={handleLoanChange} 
                            >
                                <option value=''>Select select</option>
                                {allCloudEmploymentTypes.map((option) => (
                                    <option value={option.type_name}>
                                        {option.type_name}
                                    </option>
                                ))}
                            </select>
                        </label>
                    </div>
                </div>                            

                            
                            </div>
                            </div>
                            <hr />
                            
                            
                           

                            {/* {allCloudLoanLeadID === '' && (
                                <>
                                         <div className='col-md-12 mt-2'>
                                            <div className='form-group mb-2 float-right'>
                                                <button className="btn btn-primary"> Save </button>
                                            </div>
                                        </div>
                                </>
                                )} */}

                                <div className='col-md-12 mt-2'>
                                    {allCloudLoanLeadID !== '' && (
                                        <>
                                        <div className='form-group mb-2 float-left text-success'>
                                            <b>Loan Lead ID #{allCloudLoanLeadID}</b>
                                            {/* {loanEnachId !== '' && (
                                                <b title="Enach Id">&nbsp;- EN Id #{loanEnachId}</b>
                                            )} */}

                                           
                                        </div>
                                          {formLoanValues.LoanAgreementNo !== '' && ( 
                                               <b>Loan# : {formLoanValues.LoanAgreementNo}</b> 
                                         )}
                                   </> )}

                                    {showLoanSubmitButton && (
                                        <div className='form-group mb-2 float-right'>
                                            <button className="btn btn-primary"> Save </button>
                                        </div>
                                    )}
                                </div>


                            </div>
                        </form>    
                    </div>
                    
                     { /* PRE-EMI :  update section - START HERE */ }
                     <div className='col-md-4 bg-skyblue blink-dropdown' style={{border: "2px solid #ccc", borderRadius: "3px"}}>
                        <form onSubmit={handleSubmit(handleSubmitPREEMIInfo)}>
                              <div className='row pt-3'> 
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label htmlFor="pre_emi_type">
                                            <span>Pre-EMI Type</span>
                                            <select 
                                            name='pre_emi_type'
                                            id='pre_emi_type'  
                                            className="form-select" 
                                            {...register('pre_emi_type')}
                                            value={formPREEMIValues.pre_emi_type}
                                            onChange={handlePREEMIChange}>
                                                <option value="Upfront Collection">Upfront Collection</option>
                                                <option value="Merge with EMI">Merge with EMI</option>
                                                <option value="No Pre EMI">No Pre EMI</option>
                                                <option value="Collect Later">Collect Later</option>
                                            </select>
                                        </label>                        
                                    </div>
                                </div> 
                                <div className='col-md-6'>&nbsp;</div>

                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label htmlFor="pre_emi_start_date">
                                            <span>Pre EMi Start Date</span>
                                            <input
                                                type="date"               
                                                id='pre_emi_start_date'
                                                name='pre_emi_start_date'
                                                className=  'form-control'
                                                {...register('pre_emi_start_date')}
                                                value={formPREEMIValues.pre_emi_start_date}
                                                onChange={handlePREEMIChange} 
                                            /> 
                                        </label>                        
                                    </div>
                                </div> 

                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label htmlFor="pre_emi_end_date">
                                            <span>Pre EMi End Date</span>
                                            <input
                                                type="date"               
                                                id='pre_emi_end_date'
                                                name='pre_emi_end_date'
                                                className=  'form-control'
                                                {...register('pre_emi_end_date')}
                                                value={formPREEMIValues.pre_emi_end_date}
                                                onChange={handlePREEMIChange} 
                                            /> 
                                        </label>                        
                                    </div>
                                </div> 

                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label htmlFor="pre_emi">
                                            <span>Pre-Emi</span>
                                            <input
                                                type="number"               
                                                id='pre_emi'
                                                name='pre_emi'
                                                className=  'form-control disabled'
                                                {...register('pre_emi')}
                                                value={formPREEMIValues.pre_emi}
                                                onChange={handlePREEMIChange} 
                                                readOnly="true"
                                            /> 
                                        </label>                        
                                    </div>
                                </div>

                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <label htmlFor="total_down_payment_by_customer">
                                        <span title="((Total Cost per vehicle *  No of Assets )- Loan Amount+ Upfront Collection of File charges+ Upfront Collections of Pre EMI + Upfront collections of KLI+ Processing charges including GST)">Total down payment by Customer ( Incuding PF and Other Charges)</span>
                                        <input
                                        id='total_down_payment_by_customer'
                                        name='total_down_payment_by_customer'
                                        type="number"
                                        className='form-control'
                                        {...register('total_down_payment_by_customer')}
                                        value={formPREEMIValues.total_down_payment_by_customer}
                                        onChange={handlePREEMIChange}                           
                                        />
                                        </label>
                                    </div>
                                </div>

                                 <div className='col-md-12'>
                                    <div className='form-group'>
                                        <label htmlFor="disbursement_amount_for_vehicle_including_box">
                                        <span title="Loan Amount - Processing Fee (Including GST) - Insurance by CFPL - Pre-Emi  - File Charge">Disbursement Amount For Vehicle Including Box</span>
                                        <input
                                        id='disbursement_amount_for_vehicle_including_box'
                                        name='disbursement_amount_for_vehicle_including_box'
                                        type="number"
                                        className='form-control'
                                        {...register('disbursement_amount_for_vehicle_including_box')}
                                        value={formPREEMIValues.disbursement_amount_for_vehicle_including_box}
                                        onChange={handlePREEMIChange}                           
                                        />

                                         <input
                                        id='dmemo_emi_per_vehicle'
                                        name='dmemo_emi_per_vehicle'
                                        type="number"
                                        className='form-control  d-none'
                                        {...register('dmemo_emi_per_vehicle')}
                                        value={formPREEMIValues.dmemo_emi_per_vehicle}
                                        onChange={handlePREEMIChange}                           
                                        />

                                         <input
                                        id='dmemo_emi_all_vehicle'
                                        name='dmemo_emi_all_vehicle'
                                        type="number"
                                        className='form-control d-none'
                                        {...register('dmemo_emi_all_vehicle')}
                                        value={formPREEMIValues.dmemo_emi_all_vehicle}
                                        onChange={handlePREEMIChange}                           
                                        />

                                        
                                        </label>
                                    </div>
                                </div> 

                                 {allCloudLoanLeadID === ''  && (
                                    <>
                                       <div className='col-md-12 mt-2'>
                                            <div className='form-group mb-2'>

                                                {  (camAutoApprovedStatus === true || camAutoApprovedStatus === 1)   && (
                                                    <>
                                                    <button type="button" className="btn btn-warning float-left" onClick={() => btnOpenSendMail('sanction_letter','1')}>  Send SL Mail  </button>&nbsp; 
                                                    <button type="button" onClick={() => btnOpenSendMail('delivery_order','1')} className="btn btn-success float-left">  Send DO Mail  </button>&nbsp;
                                                    </>
                                                )}
                                                <button className="btn btn-primary float-right"> Submit </button>
                                            </div>
                                        </div>
                                    </>
                                    )} 
                            {}
                                    { (camAutoApprovedStatus === true || camAutoApprovedStatus === 1)  && (
                                        <>
                                        <div className='col-md-12 mt-2 text-success'>
                                        <b>“CAM and SL auto approved by system”</b>
                                        </div></>
                                    )}
                            </div>         
                        </form> 

                        <Modal open={openModal} onClose={handleCloseModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                            <div className='modal-custom rounded'>
                                <div className='modal-head'>
                                <h4 id="modal-title">Enter Notes </h4>
                                <Button onClick={handleCloseModal} color="primary" className='btn'>
                                    <i className="bi bi-x"> &nbsp;</i>
                                </Button>
                                </div>
                
                                <div className='modal-body'>
                                
                                    <div className="row mx-0">
                                    
                                    <div className="col-md-6">
                                        <div className="form-group">
                                        <label htmlFor="itr_file">
                                            <span>Notes <a style={{ color: "red" }}>*</a></span> 
                                            <textarea
                                                id='notes'
                                                name='notes'
                                                className='form-control'
                                                {...register('notes')}
                                                onChange={handlePREEMIChange}
                                            />
                                                </label>
                                        </div>
                                    </div> 
                                    <div className="col-md-12">
                                        <div className="form-group mb-0">
                                            <button className="btn btn-primary" onClick={submitFromModal}> Submit </button>
                                        </div>
                                    </div>
                                    </div>
                                
                                </div>
                            </div>
                            </Modal>
                     </div>
                      { /* PRE-EMI :  update section - END HERE */ }
                    </div>   
                    </div>         

                </div>
            </div>

        </div>
    </div>


</div>
</div>



                    </div>
                </div>
            </Container>

        </>
    );
}
function mapStateToProps(state) {
    return {
        leadsData: state.leadsData,
        usersData: state.usersData,
        leadInfo: state.leadInfo,
        masterProfileData: state.masterProfileData,
        leadChecklistData: state.leadChecklistData,
        interactionTypeData: state.interactionTypeData,
        getUserModuleData: state.getUserModuleData,
        incidentReporteData: state.incidentReporteData,
        leadGstByLeadData: state.leadGstByLeadData,
        leadItrByLeadData: state.leadItrByLeadData,
        leadBankStatementByLeadData: state.leadBankStatementByLeadData,
        allCloudSchemesData: state.allCloudSchemesData,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign(leadActions.default, userActions.default, incidentReporteActions.default, groupsUsersActions.default,masterAction.default), dispatch),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SendToAllcloudPage);